import { rulebookMagic } from "./RulebookMagic";
export const magic = {
  "Duchowny (modlitwy do Mananna)": {
    "1": [
      "1-3 BŁOGOSŁAWIEŃSTWO PANA MÓRZ",
      "ODMÓWIONA PRZED ROZGRYWKĄ",
      "Modlitwa musi zostać odmówiona przed rozgrywką i oddziałuje na duchownego lub K3 dowolne sprzymierzone modele pieszych bohaterów lub stronników wielkości człowieka lub mniejszych (reguła nie dotyczy modeli na podstawkach, których co najmniej jedna krawędź mierzy 40 mm i więcej), które nie podlegają zasadzie specjalnej demon lub istota eteryczna lub leśny duch lub nieumarły lub opętany.\nDo końca rozgrywki objęte działaniem modlitwy modele podlegają zasadzie specjalnej wodny i zwiadowca."
    ],
    "2": [
      "4 TRÓJZĄB TRYTONA",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego.\nDopóki modlitwa pozostaje w grze dzierżony przez duchownego trójząb traktowany są jak broń z zasadą specjalną magiczny atak i precyzyjne uderzenie, a trafione i zranione orężem modele nie mogą skorzystać z Ochrony Pancerza.\nWładający trójzębem duchowny może przerzucić wszystkie nieudane rzuty na trafienie. Wynik drugiego rzutu jest ostateczny."
    ],
    "3": [
      "5 KLĄTWA ALBATROSA",
      "",
      "Moc modlitwy może zostać skierowana na pojedynczy model przeciwnika, także związany walką wręcz znajdujący się w odległości do 12” od duchownego (postać zostaje wybrana przez kierującego duchownym bez ograniczeń, z wyjątkiem tego, że duchowny musi widzieć swój cel). Do początku następnej fazy magii duchownego wszystkie modele atakującego przeklętą postać otrzymują kumulatywny modyfikator +1 do rzutu na zranienie i rzutu w tabeli Efekt zranienia.\nPostać może znajdować się pod działaniem tylko jednej klątwy na raz."
    ],
    "4": [
      "6 LITANIA NAWIGATORA",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego lub dowolny sprzymierzony model pieszy bohatera lub stronnika wielkości człowieka lub mniejszy (reguła nie dotyczy modeli na podstawkach, których co najmniej jedna krawędź mierzy 40 mm i więcej), który nie podlega zasadzie specjalnej demon lub istota eteryczna lub leśny duch lub nieumarły lub opętany.\nDopóki modlitwa pozostaje w grze objęty działaniem modlitwy model podlega zasadzie specjalnej ranger oraz sprint i uporczywość."
    ],
    "5": [
      "7 KLĄTWA TOPIELCA",
      "",
      "Po udanym odmówieniu modlitwy kierujący duchownym gracz wybiera dowolny, znajdujący się w polu widzenia i w odległości do 12” od duchownego wrogi model, który należy przykryć 3” okrągłym wzornikiem. Trafione modele, które nie podlegają zasadzie specjalnej demon lub istota eteryczna lub leśny duch lub machina wojenna lub nieumarły lub opętany lub wodny muszą wykonać udany test Wt lub zostaną Powalone na ziemię!.\nPostać może znajdować się pod działaniem tylko jednej klątwy na raz."
    ],
    "6": [
      "8 GWAŁTOWNY SZTORM",
      "POZOSTAJE W GRZE",
      "Po udanym odmówieniu modlitwy kierujący duchownym gracz wybiera dowolny, znajdujący się w polu widzenia i w odległości do 18” od duchownego obszar na powierzchni stołu, który należy przykryć 5” okrągłym wzornikiem. Dopóki modlitwa pozostaje w grze na przykrytym wzornikiem obszarze panuje wichura (zobacz paragraf Pogoda w Starym Świecie w Rozdziale 11: Scenariusze)."
    ],
    "7": [
      "9 ZBROJA MANANNA",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego.\nDopóki modlitwa pozostaje w grze duchowny otrzymuje Magiczną Ochronę na 4+, a wszystkie modele (wrogie i sprzymierzone) w kontakcie z podstawką duchownego, na początku fazy walki wręcz otrzymują jedno trafienie o Sile 4 bez możliwości skorzystania z Ochrony Pancerza."
    ]
  },
  "Duchowny (modlitwy do Ranalda)": {
    "1": [
      "1-3 UŚMIECH LOSU",
      "ODMÓWIONA PRZED ROZGRYWKĄ",
      "Modlitwa musi zostać odmówiona przed rozgrywką i oddziałuje na duchownego lub K3 dowolne sprzymierzone modele pieszych bohaterów lub stronników wielkości człowieka lub mniejszych (reguła nie dotyczy modeli na podstawkach, których co najmniej jedna krawędź mierzy 40 mm i więcej), które nie podlegają zasadzie specjalnej demon lub istota eteryczna lub leśny duch lub nieumarły lub opętany.\nDo końca rozgrywki objęte działaniem modlitwy modele podlegają zasadzie specjalnej piętno Chaosu (Tzeentcha)."
    ],
    "2": [
      "4 GRA POZORÓW",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego.\nDopóki modlitwa pozostaje w grze duchowny podlega zasadzie specjalnej genius i śmigły."
    ],
    "3": [
      "5 KLĄTWA PECHA",
      "",
      "Moc modlitwy może zostać skierowana na pojedynczy model przeciwnika, także związany walką wręcz znajdujący się w odległości do 12” od duchownego (postać zostaje wybrana przez kierującego duchownym bez ograniczeń, z wyjątkiem tego, że duchowny musi widzieć swój cel). Do początku następnej fazy magii duchownego ofiara klątwy musi przerzucić wszystkie udane rzuty na trafienie, zranienie oraz Ochronę Pancerza i Magiczną Ochronę.\nPostać może znajdować się pod działaniem tylko jednej klątwy na raz."
    ],
    "4": [
      "6 KOCI CHÓD",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego i wszystkie sprzymierzone modele znajdujące się w odległości do 12\", również związane walczą wręcz.\nDopóki modlitwa pozostaje w grze, objęte działaniem modlitwy modele podlegają zasadzie specjalnej ranger i rączy."
    ],
    "5": [
      "7 KLĄTWA KOCIOKWIKU",
      "POZOSTAJE W GRZE",
      "Po udanym odmówieniu modlitwy kierujący duchownym gracz wybiera dowolny, znajdujący się w polu widzenia i w odległości do 12” od duchownego wrogi model, który należy przykryć 3” okrągłym wzornikiem. Dopóki modlitwa pozostaje w grze trafione modele przeprowadzając test oparty na współczynniku CP wykonują rzut 3K6 odrzucając kostkę z najniższym wynikiem.\nModlitwa nie działa na modele z zasadą specjalną niezłomny. Postać może znajdować się pod działaniem tylko jednej klątwy na raz."
    ],
    "6": [
      "8 SMOLNY OPAR",
      "POZOSTAJE W GRZE",
      "Po udanym odmówieniu modlitwy kierujący duchownym gracz wybiera dowolny, znajdujący się w polu widzenia i w odległości do 18” od duchownego obszar na powierzchni stołu, który należy przykryć 5” okrągłym wzornikiem. Dopóki modlitwa pozostaje w grze na przykrytym wzornikiem obszarze unosi się mgła (zobacz paragraf Pogoda w Starym Świecie w Rozdziale 11: Scenariusze)."
    ],
    "7": [
      "9 ZBROJA RANALDA",
      "POZOSTAJE W GRZE",
      "Moc modlitwy oddziałuje na duchownego.\nDopóki modlitwa pozostaje w grze duchowny podlega zasadzie specjalnej rój nietoperzy oraz otrzymuje Magiczną Ochronę na 4+."
    ]
  },
  "Tradycja Bestii": {
    1: [
      "1-2 WŁADCA BESTII",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
        PRZYWOŁANIE (Wilk).
        `,
    ],
    2: [
      "3 RĄCZY JELEŃ",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Bursztynowego Maga, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele ignorują kary za poruszanie się po terenie trudnym, zaś
    ujemne modyfikatory za poruszanie się po terenie bardzo trudnym zmniejszone są o
    połowę (teren bardzo trudny należy traktować jako teren trudny). Modele mogą biegać po
    terenie trudnym lub terenie bardzo trudnym, a także wtedy, gdy pokonują przeszkody oraz
    automatycznie zdają wszystkie testy terenu niebezpiecznego.`,
    ],
    3: [
      "4 SKRZYDŁA SOKOŁA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 SZPONY ORŁA",
      "RZUCONY NA 7+",
      `Szpony Orła są magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE`,
    ],
    5: [
      "6 SKÓRA DZIKA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Bursztynowego Maga, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza (do
    maksymalnego poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają PANCERZA.`,
    ],
    6: [
      "7 KLĄTWA GHUR",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Ghur ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Magister Bursztynu musi widzieć
    swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone
    z postacią modele w odległości do 4” traktowane są tak jakby poruszały się po terenie
    bardzo trudnym i terenie niebezpiecznym.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE GHUR",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE.
    `,
    ],
    8: [
      "9 UCZTA KRUKÓW",
      "RZUCONY NA 11+",
      `Uczta Kruków jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PRECYZYJNE UDERZENIE. `,
    ],
    9: [
      "10 ZBROJA GHUR",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Sztukmistrza, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PRECYZYJNE UDERZENIE.
    `,
    ],
    10: [
      "11 OSTRZE GHUR",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRECYZYJNE UDERZENIEoraz premia +3 do SIŁYmaterializuje się w dłoni
    MAGA. Ponadto, Magister Bursztynu władający Ostrzem Ghur otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Ghur - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 GNIEW NIEDŹWIEDZIA",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnikaw odległości do 8”, nawet jeśli go nie widzi. Czar może zostać rzucony na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym niedźwiedź. Uzyskuje zdolność broń
    naturalna, +3 ATAKI, +2 do SIŁY oraz +1 do WT. Model pozostający pod wpływem
    zaklęcia, nie może używać oręża, tarczy & pancerza.
    `,
    ],
  },
  "Tradycja Cienia": {
    1: [
      "1-2 SOBOWTÓR",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który nie podlega zasadzie specjalnej
    NAJEMNE OSTRZE, CHORĄŻY, SYGNALISTA, DEMON, ISTOTA ETERYCZNA, LEŚNY
    DUCH, NIEUMARŁY, FANATYK, FURIA, NIENAWIŚĆ lub ZWIERZĘ.
    Objęty działaniem zaklęcia model podlega zasadzie specjalnej INFILTRACJA.`,
    ],
    2: [
      "3 KLĄTWA TAŃCA ROZPACZY",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Klątwa Tańca Rozpaczy ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Cienia musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy w ramach ruchów przymusowych w czasie rozgrywania fazy
    ruchu porusza się o K3” w losowo określonym kierunku (w przypadku gdy na Kostce
    Rozrzutu wypadnie wynik TRAFIENIE!, kierunek ruchu wybiera kierujący MAGIEM
    gracz). Jeżeli ruch oznaczałby wejście w kontakt z innym modelem, należy zatrzymać
    dotkniętą działaniem zaklęcia postać 1” od modelu.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 SKRZYDŁA Z CIENIA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 SZTYLETY Z CIENIA",
      "RZUCONY NA 7+",
      `Sztylety z Cienia są magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 bez możliwości skorzystania z
    Ochrony Pancerza.`,
    ],
    5: [
      "6 WIDMOWY RUCH",
      "RZUCONY NA 9+",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 8" od Sztukmistrza. Objęte działaniem czaru modele mogą wykonać ruch
    jak w fazie ruchu, który może być również ruchem szarży (szarża ta podlegać będzie
    wszystkim zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży
    modelu, który wykonał widmowy ruch).`,
    ],
    6: [
      "7 KLĄTWA ULGU",
      "RZUCONY NA 10+",
      `Klątwa Ulgu ma zasięg 24”. Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego
    wzornika i przykryć nim wybrany na cel model przeciwnika, także związany walką wręcz
    (wybrany przez kierującego MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że
    Magister Cienia musi widzieć swój cel). Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Do początku następnej fazy magii rzucającego zaklęcie
    MAGA objęte działaniem zaklęcia modele traktowane są tak jakby znajdowały się poza
    czasem. Ofiara klątwy nie może podejmować żadnej akcji i dryfuje bezczynnie w
    anomalii. Uwzględniając ten stan rzeczy w momencie określania czy drużyna musi
    wykonać test rozbicia, objęte działaniem zaklęcia modele nie są liczone do całkowitej
    liczby postaci w kompanii. Ponadto, należy zauważyć, że znajdujący się poza
    strumieniem czasu MAG lub DUCHOWNY lub KOWAL RUN nie może rzucać zaklęć,
    ponadto nie generuje Kostek Mocy oraz Kostek Rozproszenia.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz`,
    ],
    7: [
      "8 ZAMĘT ULGU",
      "RZUCONY NA 11+, POZOSTAJE W GRZE",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Dopóki zaklęcie 'pozostaje w grze'
    objęte działaniem klątwy modele podlegają zasadzie specjalnej GŁUPOTA.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    8: [
      "9 TANIEC CIENI",
      "RZUCONY NA 11+",
      `Taniec Cieni jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 ZBROJA ULGU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Sztukmistrza, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE ULGU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Magister Cienia władający Ostrzem Ulgu otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Ulgu - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 NEGACJA ATAKU",
      "RZUCONY NA 15+",
      `Zaklęcie Negacja ataku jest czarem wyjątkowym, może zostać rzucone przez MAGA
    który odniósł obrażenia, został Oszołomiony!, Powalony na ziemię! a nawet został Wyłączony
    z akcji!. MAG może podjąć próbę rzucenia zaklęcia w następnej fazie magii (należy
    zignorować zasady według których Oszołomiony!, Powalony na ziemię! lub Wyłączony z akcji!
    MAG nie może rzucać zaklęć) i jeśli czar zostanie rzucony pomyślnie, moc zaklęcia
    neguje wszelkie obrażenia odniesione podczas poprzedniej tury tak, jakby rany nigdy
    nie zostały zadane – bo nie zostały zadane!`,
    ],
  },
  "Tradycja Metalu": {
    1: [
      "1-2 KUŹNIA CHAMONU",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. Moc zaklęcia oddziałuje na K3 sztuki,
    dzierżonego przez bohaterów lub stronników i wybranego przez gracza oręża do walki
    wręcz. Do końca potyczki wszystkie rzuty na zranienie objętego działaniem zaklęcia oręża
    wykonywane są z dodatnim modyfikatorem +1. Ponadto, jeśli broń nie posiadała takiej
    cechy wcześniej, to zyskuje cechę oręża PRZEBICIE PANCERZA.`,
    ],
    2: [
      "3 KLĄTWA OŁOWIU",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Klątwa Ołowiu ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Magister Metalu musi widzieć swój
    cel). Dopóki zaklęcie 'pozostaje w grze' ofiary klątwy traci swoje dotychczasowe
    właściwości. Walczący przeklętym orężem model trafia jedynie w przypadku gdy
    wypadnie naturalny dublet w udanym rzucie na trafienie (żadne modyfikatory i zasady
    specjalnie nie mają zastosowania – liczy się jedynie naturalny dublet w udanym rzucie na
    trafienie), a udane trafienia mają SIŁĘ 1. Klątwa nie działa na broń magiczną oraz mechaniczną
    i runiczną.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 SKRZYDŁA PEGAZA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 DESTYLACJA PŁYNNEGO SREBRA",
      "RZUCONY NA 7+",
      `Sztylety cienia są magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 METODA PRÓB & BŁĘDÓW",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Moc zaklęcia oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące
    się w odległości do 8" od Alchemika, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele mogą przerzucić kostki w rzucie na trafienie, zranienie oraz
    Ochronę Pancerza i Ochronę Magiczną.`,
    ],
    6: [
      "7 KLĄTWA CHAMON",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Chamon ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Magister Metalu musi widzieć swój
    cel). Dopóki zaklęcie 'pozostaje w grze' pancerz wroga, jego oręż i wyposażenie
    zmieniają się w ołów. Ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 4” muszą przerzucić wszystkie udane rzuty na trafienie oraz rzuty na
    Ochronę Pancerza.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE CHAMON",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 SREBRZYSTE STRZAŁY ARHA",
      "RZUCONY NA 11+",
      `Srebrzyste strzały Archa są niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”.
    Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim
    wybrany na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie
    o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 ZBROJA CHAMON",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Alchemika, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE CHAMON",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Magister Metalu władający Ostrzem Chamon otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Chamon - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 DUCH KUŹNI",
      "RZUCONY NA 14+",
      `Zaklęcie Duch Kuźni jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”.
    Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim
    wybrany na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie
    o SILE 1, jeżeli nie dysponują Ochroną Pancerza; trafienie o SILE 2, jeżeli dysponują Ochroną
    Pancerza na 6+; trafienie o SILE 3, jeżeli dysponują Ochroną Pancerza na 5+; trafienie o SILE
    4, jeżeli dysponują Ochroną Pancerza na 4+; trafienie o SILE 5, jeżeli dysponują Ochroną
    Pancerza na 3+; trafienie o SILE 6, jeżeli dysponują Ochroną Pancerza na 2+ oraz trafienie o
    SILE 7, jeżeli dysponują Ochroną Pancerza na 1+ bądź lepszą z cechą oręża PŁONĄCY ATAK,
    bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
  },
  "Tradycja Niebios": {
    1: [
      "1-2 ZWIASTUN PRZYSZŁOŚCI",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych).
    Do końca potyczki model może przerzucić wszystkie nieudane rzuty na trafienie i
    zranienie. Nieudane rzuty na trafienie i zranienie uzyskane w przerzucie nie podlegają
    dalszemu przerzuceniu – nie można nigdy przerzucić już przerzuconych kostek.`,
    ],
    2: [
      "3 SZAFIROWY PORTAL",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’ drzwi, przez
    które model może wykonać ruch jak w fazie ruchu, który może być również ruchem
    szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego, że nie
    można próbować przejąć szarży modelu, który przekroczył szafirowy portal).`,
    ],
    3: [
      "4 NIEBIAŃSKIE SKRZYDŁA",
      "RZUCONY NA 7+",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 BŁYSKAWICA",
      "RZUCONY NA 7+",
      `Błyskawica to magiczny pocisk o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny pocisk
    uderza w cel powodując trafienie o SILE 4 bez możliwości skorzystania z Ochrony
    Pancerza.`,
    ],
    5: [
      "6 PIERWSZE UDERZENIE",
      "RZUCONY NA 8+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Astromanty, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' broń objętych działaniem czaru modeli otrzymuje cechę oręża UDERZA
    JAKO PIERWSZY.`,
    ],
    6: [
      "7 KLĄTWA AZYR",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Azyr ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Astromanta musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 4” mogą zostać obrane na cel czarów typu magiczny pocisk oraz ataków
    bronią dystansową nawet, jeśli atakujący nie widzi celu lub przeklęty model Ukrywa się.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE AZYR",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    8: [
      "9 PIORUN URANONA",
      "RZUCONY NA 11+",
      `Piorun Uranona jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 ZBROJA AZYR",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Astromanty, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE AZYR",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża UDERZA JAKO PIERWSZY oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Magister Niebios władający Ostrzem Azyr otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Azyr - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 KLĄTWA FATUM",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Klątwa Fatum ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Astromanta musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli zostanie
    trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Tradycja Ognia": {
    1: [
      "1-2 GOREJĄCY MIECZ RHUIN",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. Moc zaklęcia oddziałuje na K3 sztuki,
    dzierżonego przez bohaterów lub stronników i wybranego przez gracza oręża do walki
    wręcz. Do końca potyczki broń zyskuje cechę oręża PŁONĄCY ATAK.`,
    ],
    2: [
      "3 PŁOMIENNA KLĄTWA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Płomienna klątwa ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Piromanta musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy staje się ŁATWOPALNA.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 SKRZYDŁA FENIKSA",
      "RZUCONY NA 7+",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 OGIEŃ U’ZHUL",
      "RZUCONY NA 7+",
      `Ogień U’zhul to magiczny pocisk o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny pocisk
    uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 POTĘGA AQSHY",
      "RZUCONY NA 8+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Piromanty, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' broń objętych działaniem czaru modeli otrzymuje cechę oręża
    PŁONĄCY ATAK.`,
    ],
    6: [
      "7 KLĄTWA AQSHY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Aqshy ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Piromanta musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 4” mogą zostać obrane na cel czarów oraz ataków bronią dystansową, które
    podlegają zasadzie specjalnej PŁONĄCY ATAK nawet jeśli atakujący nie widzi celu lub
    przeklęty model Ukrywa się.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE AQSHY",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 OGNISTA KULA",
      "RZUCONY NA 11+",
      `Ognista Kula jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 ZBROJA AQSHY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Piromanty, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE AQSHY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Magister Ognia władający Ostrzem Aqshy otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Aqshy - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 OGNISTE ODRODZENIE FENIKSA",
      "RZUCONY NA 14+, POZOSTAJE W GRZE",
      `Jeśli w trakcie rozgrywania potyczki Magister Ognia zostanie Wyłączony z akcji!, a zaklęcie
    'pozostaje w grze', należy użyć 3” okrągłego wzornika i przykryć nim model MAGA.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+ (za
    wyjątkiem samego rzucającego!). Objęte działaniem zaklęcia modele otrzymują trafienie
    o SILE 4 z cechą oręża PŁONĄCY ATAK.
    W najbliższej fazie ruchu model MAGA powstaje podczas wykonywania pozostałych
    ruchów, tak jak postać która była Oszołomiona!. Magister Aqshy może wykonać ruch (ale
    nie bieg), rzucać zaklęcia oraz strzelać. Jeśli model pozostaje związany walką wręcz to
    końca trwania tury w której powstał, będzie UDERZAŁ JAKO OSTATNI, bez względu na
    wartość I, oręż którym walczy lub inne zasady specjalne. Ponadto od momentu powstania
    Piromantę należy traktować tak, jakby wciąż posiadał 1 punkt ŻW.`,
    ],
  },
  "Tradycja Śmierci": {
    1: [
      "1-2 ŚMIECH ŻNIWIARZA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych).
    Objęty działaniem zaklęcia model podlega zasadzie specjalnej STRACH i
    ZIMNOKRWISTY.`,
    ],
    2: [
      "3 KLĄTWA ROZPACZY",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Klątwa Rozpaczy ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Śmierci musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy przeprowadzając test oparty na współczynniku CP
    wykonuje rzut 3K6 odrzucając kostkę z najniższym wynikiem.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 SKRZYDŁA KRUKA",
      "RZUCONY NA 7+",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 POSŁANIEC ŚMIERCI",
      "RZUCONY NA 7+",
      `Posłaniec Śmierci jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża DRUZGOCZĄCY.`,
    ],
    5: [
      "6 AKCEPTACJA PRZEZNACZENIA",
      "RZUCONY NA 8+, POZOSTAJE W GRZE",
      `MAG może rzucić to zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model podlega zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    6: [
      "7 KLĄTWA SHYISH",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Shyish ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Śmierci musi widzieć swój cel). Po udanym
    rzuceniu zaklęcia należy umieścić obok ofiary czaru sześciościenną kostkę, tak aby
    wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku każdej kolejnej
    fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1 większy. Wynik
    na kostce oznacza ujemny modyfikator do współczynników SZ, S i WT jaki otrzymuje
    ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w odległości do 8”.
    Należy zauważyć, że współczynniki mogą zostać obniżone do minimalnej wartości 1.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 KRĄG ŚMIERCI",
      "RZUCONY NA 11+, POZOSTAJE W GRZE",
      `Po udanym rzuceniu zaklęcia kierujący MAGIEM gracz wybiera dowolny, niezajęty przez
    wrogie modele, obszar na powierzchni stołu, który należy przykryć 3” okrągłym
    wzornikiem. Dopóki zaklęcie pozostaje w grze modele podlegające zasadzie specjalnej
    NIEUMARŁY traktują teren przykryty wzornikiem jako teren niedostępny.`,
    ],
    8: [
      "9 KOSA ŻNIWIARZA",
      "RZUCONY NA 11+",
      `Kosa Żniwiarza jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża DRUZGOCZĄCY.`,
    ],
    9: [
      "10 ZBROJA SHYISH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Magistra Shyish, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    DRUZGOCZĄCY.`,
    ],
    10: [
      "11 OSTRZE SHYISH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża DRUZGOCZĄCY oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Magister Śmierci władający Ostrzem Shyish otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Shyish - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 KLĄTWA CZARNEGO HUMORU",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `Klątwa Shyish ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Śmierci musi widzieć swój cel). Ofiara klątwy
    zostaje Powalona na ziemię! i upada zanosząc się upiornym, histerycznym śmiechem. By
    ustalić czy ofiara zaklęcia ‘pęknie ze śmiechu’, obydwaj gracze rzucają natychmiast K6.
    Jeżeli gracz, którego MAG rzucał zaklęcie uzyska wynik równy bądź niższy od
    przeciwnika, model dalej zanosi się śmiechem i w następnej turze wciąż traktowany jest
    jako Powalony na ziemię!, jeżeli jednak uzyska wynik wyższy od przeciwnika, model ‘pęka
    ze śmiechu’ i zostaje Wyłączony z akcji!. Gracze rzucają K6 i powtarzają całą procedurę
    w każdej fazie magii, póki gracz dowodzący magiem nie uzyska wyniku wyższego od
    przeciwnika lub klątwa nie zostanie rozproszona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Tradycja Światła": {
    1: [
      "1-2 JASNOŚĆ UMYSŁU",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych).
    Objęty działaniem zaklęcia model podlega zasadzie specjalnej NIEZŁOMNOŚĆ i
    ZIMNOKRWISTY.`,
    ],
    2: [
      "3 STRAŻNICZE ŚWIATŁO",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Hierofanty, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele pozostające w zasięgu działania zaklęcia mogą przerzucić
    każdy nieudany test STRACHU lub GROZY.`,
    ],
    3: [
      "4 ŚWIETLISTE SKRZYDŁA",
      "RZUCONY NA 7+",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 PŁONĄCE WEJRZENIE",
      "RZUCONY NA 7+",
      `Płonące Wejrzenie jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PRECYZYJNE
    UDERZENIE. Istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz DEMONY i
    OPĘTANI otrzymują trafienie o SILE 6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    5: [
      "6 SIEĆ AMYNTHOKA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Sieć Amynthoka ma zasięg 24” i może zostać rzucona na dowolny model przeciwnika,
    również związany walką wręcz, który znajduje się w polu widzenia MAGA. Po udanym
    rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany na cel model
    przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie
    przykryte wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele,
    których podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+.
    Dopóki zaklęcie ‘pozostaje w grze’ objęte działaniem klątwy modele podlegają zasadzie
    specjalnej GŁUPOTA. Istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz DEMONY i
    OPĘTANI przeprowadzając test GŁUPOTY wykonują rzut 3K6 odrzucając kostkę z
    najniższym wynikiem.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    6: [
      "7 KLĄTWA HYSH",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Hysh ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Światła musi widzieć swój cel). Dopóki
    zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele
    w odległości do 4” nie mogą się UKRYĆ oraz korzystać z osłon.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 OCHRONA PHA",
      "RZUCONY NA 11+, POZOSTAJE W GRZE",
      `Po udanym rzuceniu zaklęcia kierujący MAGIEM gracz wybiera dowolny, niezajęty przez
    wrogie modele, obszar na powierzchni stołu, który należy przykryć 3” okrągłym
    wzornikiem. Dopóki zaklęcie pozostaje w grze modele podlegające zasadzie specjalnej
    NIEUMARŁY, ETERYCZNY, LEŚNE DUCHU oraz DEMONY i OPĘTANI traktują teren
    przykryty wzornikiem jako teren niedostępny.`,
    ],
    8: [
      "9 KOLUMNA ŚWIATŁOŚCI",
      "RZUCONY NA 11+",
      `Kolumna Światłości jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany na
    cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których podstawki są
    całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te
    modele, których podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na
    4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE 4 z cechą oręża
    PRECYZYJNE UDERZENIE. Istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz
    DEMONY i OPĘTANI otrzymują trafienie o SILE 6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    9: [
      "10 ZBROJA HYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Hierofanty, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PRECYZYJNE UDERZENIE. Istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz
    DEMONY i OPĘTANI otrzymują trafienie o SILE 6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    10: [
      "11 OSTRZE HYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRECYZYJNE UDERZENIE oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Magister Światła władający Ostrzem Hysh otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Hysh - magicznego oręża nie można łączyć z inną bronią. Ostrze
    Hysh użyte przeciwko istotom NIEUMARŁYM, ETERYCZNYM, LEŚNYM DUCHOM oraz
    DEMONOM i OPĘTANYM zyskuje cechę oręża DRUZGOCZĄCY.`,
    ],
    11: [
      "12 ŚWIĘTA TARCZA IGNATUSA",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 8" od Hierofanty, również takie, które walczą wręcz. Dopóki zaklęcie 'pozostaje
    w grze' modele pozostające w zasięgu działania zaklęcia otrzymują Magiczną Ochronę na 4+,
    ponadto wrogie postacie atakujące modele chronione Świętą Tarczą Ignatusa otrzymują
    modyfikator -1 do rzutu na trafienie. Istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz
    DEMONY i OPĘTANI trafiają objęte działaniem zaklęcia modele jedynie w przypadku gdy
    wypadnie naturalny dublet w udanym rzucie na trafienie (żadne modyfikatory i zasady
    specjalnie nie mają zastosowania – liczy się jedynie naturalny dublet w udanym rzucie na
    trafienie).`,
    ],
  },
  "Tradycja Życia": {
    1: [
      "1-2 UZDROWIENIE",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych).
    Objęty działaniem zaklęcia model podlega zasadzie specjalnej REGENERACJA.`,
    ],
    2: [
      "3 WROTA ZIEMI",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy Wrota Ziemi łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które model może wykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Wrota Ziemi).`,
    ],
    3: [
      "4 SKRZYDŁA SOWY",
      "RZUCONY NA 7+",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 CIERŃ",
      "RZUCONY NA 7+",
      `Cierń jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny pocisk
    uderza w cel powodując trafienie o SILE 4 z cechą oręża DRUZGOCZĄCY.`,
    ],
    5: [
      "6 ZWIERCIADŁO BÓLU",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub dowolny sprzymierzony model bohatera lub
    stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na PIESZY
    model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na modele na
    podstawkach 40x40 mm i większych), również związany walką wręcz.
    Dopóki zaklęcie 'pozostaje w grze' wrogie modele które zaatakują i wykonają
    udany rzut na trafienie otrzymują trafienie z taką samą SIŁĄ i właściwościami jak cios,
    który zadały.`,
    ],
    6: [
      "7 KLĄTWA GHYRAN",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Ghyran ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Życia musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 4” nie mogą biegać, ponadto wartość współczynnika SZ zostaje
    zmniejszona o połowę (ewentualne ułamki należy zaokrąglić w górę). Modele
    podlegające zasadzie specjalnej LOT, nie mogą latać i biegać, jednak wartość ich
    współczynnika SZ pozostaje bez zmian.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE GHYRAN",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża DRUZGOCZĄCY.`,
    ],
    8: [
      "9 GRAD KAMIENI",
      "RZUCONY NA 11+",
      `Grad Kamieni jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża z cechą oręża DRUZGOCZĄCY.`,
    ],
    9: [
      "10 ZBROJA GHYRAN",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+, a wrogie
    modele które zaatakują Magistra Jadeitu i wykonają udany rzut na trafienie otrzymują
    trafienie z taką samą SIŁĄ i właściwościami jak cios, który zadały.`,
    ],
    10: [
      "11 OSTRZE GHYRAN",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża DRUZGOCZĄCY oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Magister Życia władający Ostrzem Ghyran otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Ghyran - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 DAR ŻYCIA",
      "RZUCONY NA 14+",
      `MAG może rzucić zaklęcie na dowolny sprzymierzony model bohatera lub stronnika,
    który został Wyłączony z akcji!. Udane rzucenie sprawia, że model odzyskuje wszystkie
    utracone punkty ŻW i kontynuuje turę normalnie. W przypadku modeli dosiadających
    POTWORA, gracz musi wybrać pomiędzy WIERZCHOWCEM, a KAWALERZYSTĄ.
    Zaklęcie nie działa na istoty NIEUMARŁE, ETERYCZNE, LEŚNE DUCHY oraz
    DEMONY i OPĘTANYCH, MACHINY WOJENNE.`,
    ],
  },
  "Tradycja Lodu": {
    1: [
      "1-2 EGIDA MISKI",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG może rzucić czar na samego
    siebie lub dowolny sprzymierzony model bohatera lub stronnika. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych).
    Do końca potyczki objęty działaniem zaklęcia model w każdej fazie walki wręcz
    traktowany jest tak, jakby bronił przeszkody (zobacz ROZDZIAŁ XI: ELEMENTY
    TERENU NA POLU BITWY).`,
    ],
    2: [
      "3 TARCZA MISKI",
      "RZUCONY NA 8+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Magistra Lodu, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele pozostające w zasięgu działania zaklęcia otrzymują Magiczną
    Ochronę na 4+ przeciwko zwykłym i magicznym pociskom.`,
    ],
    3: [
      "4 SKRZYDŁA MISKI",
      "RZUCONY NA 8+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 LODOWE GROTY",
      "RZUCONY NA 7+",
      `Lodowe groty są magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE 4 bez możliwości skorzystania z Ochrony
    Pancerza.`,
    ],
    5: [
      "6 ZAWODZĄCY WIATR",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Magistra Lodu, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele objęte działaniem zaklęcia Zawodzący Wiatr nie mogą być
    obrane na cel strzelania z broni dystansowej o SILE 4 lub mniej. Moc zaklęcia nie obejmuje
    swym działaniem MACHIN WOJENNYCH, które mogą strzelać do dotkniętego jego
    działaniem obszaru w zwykły sposób.`,
    ],
    6: [
      "7 KLĄTWA MISKI",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Miski ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Magister Lodu musi widzieć swój cel). Po udanym
    rzuceniu zaklęcia należy umieścić obok ofiary czaru sześciościenną kostkę, tak aby
    wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku każdej kolejnej
    fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1 większy. Wynik
    na kostce oznacza ujemny modyfikator do współczynników SZ, S i WT jaki otrzymuje
    ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w odległości do 8".
    Należy zauważyć, że współczynniki mogą zostać obniżone do minimalnej wartości 1.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE MISKI",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    8: [
      "9 LODOWY WIATR",
      "RZUCONY NA 11+",
      `Lodowy Wiatr jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 ZBROJA LODU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Magistra Lodu, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE MISKI",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Magister Lodu władający Ostrzem Miski otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Miski - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 GNIEW URSUNA",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Czar może zostać rzucony na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym niedźwiedź. Uzyskuje zdolność broń
    naturalna, +3 ATAKI, +2 do SIŁY oraz +1 do WT. Model pozostający pod wpływem
    zaklęcia, nie może używać oręża, tarczy & pancerza.`,
    ],
  },
  "Magia Żywiołów": {
    1: [
      "1-2 PIERWSZE ŻYCZENIE IBN JELLABA",
      "RZUCONY AUTOMATYCZNIE",
      `Zaklęcie musi zostać rzucone przed potyczką. Moc zaklęcia pozwala wpływać geniusom
    na przebieg rozgrywki. Na początku potyczki, przed turą pierwszego gracza należy zebrać
    pulę Kostek Przeznaczenia. Pula składa się z K3 kostek K6. Po ustalenie puli Kostek
    Przeznaczenia gracz wykonuje rzut.
    Kostki Przeznaczenia z wylosowanymi WYNIKAMI należy umieścić w widocznym
    miejscu przed graczem lub też w pudełku, czy innym wygodnym miejscu, które
    uniemożliwi pomieszanie ich z innymi kostkami używanymi w czasie gry.
    W trakcie rozgrywki gracz może użyć wybranego przez siebie WYNIKU na Kostce
    Przeznaczenia do modyfikacji dowolnego rzutu lub testu wykonywanego przez dowolny
    model bohatera. Wykorzystany WYNIK należy usunąć z puli WYNIKÓW Kostek
    Przeznaczenia. WYNIKI, które nie zostaną wykorzystane w trakcie potyczki przepadają i
    nie mogą być użyte w czasie rozgrywania sekwencji po potyczce.`,
    ],
    2: [
      "3 WROTA DAO",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy Wrota Dao łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 18” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które model może wykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Wrota Dao).`,
    ],
    3: [
      "4 SKRZYDŁA DŻINNA",
      "RZUCONY NA 8+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie czaru oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 OGIEŃ IFRYTA",
      "RZUCONY NA 7+",
      `Ogień Ifryta to magiczny pocisk o zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny pocisk
    uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 MIRAŻ MARIDY",
      "RZUCONY NA 9 +, POZOSTAJE W GRZE",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Wezyra. Dopóki zaklęcie 'pozostaje w grze' modele wydają się
    znajdować kilka kroków od prawdziwej pozycji, a wszystkie ataki (zarówno w fazie
    strzelania jak i w fazie walki wręcz) wymierzone w objęte działaniem zaklęcia modele
    wykonywane są z karą -1 do rzutu na trafienie.`,
    ],
    6: [
      "7 DRUGIE ŻYCZENIE AL MUKTARA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Drugie Życzenie ma zasięg 18”. Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego
    wzornika i przykryć nim wybrany na cel model przeciwnika, także związany walką wręcz
    (wybrany przez kierującego MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że
    Magister Żywiołów musi widzieć swój cel). Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Do początku następnej fazy magii rzucającego zaklęcie
    MAGA objęte działaniem zaklęcia modele traktowane są tak jakby znajdowały się poza
    czasem. Ofiara klątwy nie może podejmować żadnej akcji i dryfuje bezczynnie w
    anomalii. Uwzględniając ten stan rzeczy w momencie określania czy drużyna musi
    wykonać test rozbicia, objęte działaniem zaklęcia modele nie są liczone do całkowitej
    liczby postaci w kompanii. Ponadto, należy zauważyć, że znajdujący się poza
    strumieniem czasu MAG lub DUCHOWNY lub KOWAL RUN nie może rzucać zaklęć,
    ponadto nie generuje Kostek Mocy oraz Kostek Rozproszenia.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE ŻYWIOŁÓW",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża ZATRUTY ATAK.`,
    ],
    8: [
      "9 PIĘŚĆ MARIDY",
      "RZUCONY NA 11+",
      `Pięść Maridy jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 KORONA IFRYTA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Wezyra, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE DŻINNÓW",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża UDERZA JAKO PIERWSZY oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Wezyr władający Ostrzem Dżinnów otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Dżinnów - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 TRZECIE ŻYCZENIE SUŁTANA JAFFARA",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Trzecie Życzenie ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Wezyr musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli zostanie
    trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Magia Asrai": {
    1: [
      "1-2 UKRYTA ŚCIEŻKA",
      "RZUCONY NA 5+, POZOSTAJE W GRZE",
      `MAG może rzucić to zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Czar może zostać rzucony
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Dopóki zaklęcie 'pozostaje w grze' modele traktują na potrzeby ruchu (ale nie pola
    widzenia) wszystkie elementy terenu jak teren otwarty.`,
    ],
    2: [
      "3 PLEMIĘ PÓŁMROKU",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Maga Leśnych Elfów, również związane walką wręcz.
    Dopóki zaklęcie 'pozostaje w grze' modele wydają się znajdować kilka kroków od
    swojej prawdziwej pozycji, a wszystkie ataki (zarówno w fazie strzelania jak i w fazie walki
    wręcz) wymierzone w poddany działaniu zaklęcia model wykonywane są z karą -1 do
    rzutu na trafienie.`,
    ],
    3: [
      "4 SKRZYDŁA SOKOŁA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 DRZAZGA",
      "RZUCONY NA 7+",
      `Drzazga jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    5: [
      "6 WIDMOWY RUCH",
      "RZUCONY NA 9+",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Maga Leśnych Elfów. Objęte działaniem czaru modele mogą
    wykonać ruch jak w fazie ruchu, który może być również ruchem szarży (szarża ta
    podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego, że nie można próbować
    przejąć szarży modelu, który wykonał Widmowy Ruch).`,
    ],
    6: [
      "7 KLĄTWA KNIEI",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Kniei ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Mag Leśnych Elfów musi widzieć
    swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone
    z postacią modele w odległości do 6” traktowane są tak jakby poruszały się po terenie
    bardzo trudnym i terenie niebezpiecznym.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE PÓŁMROKU",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    8: [
      "9 PTAKI CIERNISTYCH KRZEWÓW",
      "RZUCONY NA 11+",
      `Ptaki Ciernistych Krzewów są niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”.
    Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim
    wybrany na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie
    o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    9: [
      "10 ZBROJA PÓŁMROKU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Maga Leśnych Elfów, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą
    oręża PRECYZYJNE UDERZENIE.`,
    ],
    10: [
      "11 OSTRZE PÓŁMROKU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRECYZYJNE UDERZENIE oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Mag Leśnych Elfów władający Ostrzem Półmroku otrzymuje dodatkowy
    +1 ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Półmroku - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 FURIA KNIEI",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Czar może zostać rzucony
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym niedźwiedź. Uzyskuje zdolność broń
    naturalna, +3 ATAKI, +2 do SIŁY oraz +1 do WT. Model pozostający pod wpływem
    zaklęcia, nie może używać oręża, tarczy & pancerza.`,
    ],
  },
  "Wysoka Magia": {
    1: [
      "1-2 SZAFIROWY PORTAL",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które model może wykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Szafirowy Portal).`,
    ],
    2: [
      "3 WYSSANIE MAGII",
      "RZUCONY NA 6+",
      `Czar działa do początku następnej fazy magii MAGA. Wartość rzucenia wszystkich zaklęć
    splatanych w czasie trwania Wyssania Magii zostaje zwiększony o +3.`,
    ],
    3: [
      "4 SKRZYDŁA FENIKSA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 SZPONY FENIKSA",
      "RZUCONY NA 7+",
      `Szpony Feniksa są magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 TARCZA SAPHERY",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Moc zaklęcia oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące
    się w odległości do 12" od Maga Elfów Wysokiego Rodu również takie, które walczą wręcz.
    Dopóki zaklęcie 'pozostaje w grze' objęte działaniem zaklęcia modele otrzymują
    Magiczną Ochronę na 5+.`,
    ],
    6: [
      "7 KLĄTWA QHAYSH",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Qhaysh ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Mag Elfów Wysokiego Rodu musi widzieć swój cel). Po
    udanym rzuceniu zaklęcia należy umieścić obok ofiary czaru sześciościenną kostkę, tak
    aby wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku każdej
    kolejnej fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1 większy.
    Wynik na kostce oznacza ujemny modyfikator do współczynników SZ, S i WT jaki
    otrzymuje ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w odległości
    do 6". Należy zauważyć, że współczynniki mogą zostać obniżone do minimalnej
    wartości 1.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE QHAYSH",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 OGIEŃ FENIKSA",
      "RZUCONY NA 11+",
      `Ogień Feniksa jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 ZBROJA QHAYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Maga Elfów Wysokiego Rodu, na początku fazy walki wręcz otrzymują jedno trafienie o SILE
    4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE QHAYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Mag Elfów Wysokiego Rodu władający Ostrzem Qhaysh otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Qhaysh - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 PŁOMIENIE QHAYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Zaklęcie Płomienie Qhaysh jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu
    24”. Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim
    wybrany na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone),
    których podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem
    zaklęcia automatycznie, te modele, których podstawki są częściowo przykryte, dostają
    się pod działanie zaklęcia na 4+. Objęte działaniem zaklęcie modele otrzymują
    automatyczne trafienie o SILE 3 z cechą oręża PŁONĄCY ATAK. Ponadto, jeśli na początku
    następnej fazy magii gracza Elfów Wysokiego Rodu z Ulthuanu zaklęcie nadal 'pozostaje w
    grze', objęte działaniem czaru modele otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY
    ATAK. Jeśli czar 'pozostaje w grze' w kolejnej fazie magii rzucającego, modele otrzymują
    trafienie o SILE 5 z cechą oręża PŁONĄCY ATAK, SIŁA trafienia zwiększa się o +1 z każdą
    kolejną turę.`,
    ],
  },
  "Mroczna Magia": {
    1: [
      "1-2 PIEKIELNY WRZASK",
      "RZUCONY NA 8+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Modele objęte działaniem zaklęcia
    muszą wykonać test CP. Nieudany test oznacza, że modele Uciekają!. Zaklęcie nie
    działa na istoty podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    2: [
      "3 POTĘGA MROKU",
      "RZUCONY NA 6+",
      `Po udanym rzuceniu zaklęcia Potęga Mroku, Wieszczka Khaina uzyskuje natychmiast
    dodatkowe K3 Kostki Mocy. Kostki te dodawane są do tych, które pozostają w
    dyspozycji Wieszczki Khaina, ale należy trzymać je oddzielnie lub użyć kostek innego
    koloru. Dodatkowych kostek nie można używać do rozpraszania czarów
    pozostających w grze, ani w jakikolwiek sposób przechowywać ich z tury na turę. Za
    każdą niewykorzystaną na koniec fazy magii Kostkę Mocy Wieszczka Khaina otrzymuje
    automatyczne trafienie o SILE K6.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 POCISK ZAGŁADY",
      "RZUCONY NA 7+",
      `Pocisk Zagłady jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża SKRYTOBÓJCZY.`,
    ],
    5: [
      "6 FANTASMAGORIA",
      "RZUCANY NA 10+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie 'pozostaje w grze', wszystkie wrogie modele znajdujące się na stole
    przeprowadzając test oparty na współczynniku CP wykonują rzut 3K6 odrzucając
    kostkę z najniższym wynikiem.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    6: [
      "7 KLĄTWA PANA WĘŻY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Pana Węży ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Wieszczka Khaina musi widzieć
    swój cel). Dopóki zaklęcie 'pozostaje w grze' wszystkie trafienia zadane ofierze klątwy
    oraz wszystkim sprzymierzonym z postacią modelom w odległości do 6” podlegają
    zasadzie specjalnej ZATRUTY ATAK.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 KORONA DHAR",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża SKRYTOBÓJCZY.`,
    ],
    8: [
      "9 FURIA KHAINA",
      "RZUCONY NA 11+",
      `Furia Khaina jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża SKRYTOBÓJCZY.`,
    ],
    9: [
      "10 ZBROJA DHAR",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Wieszczki Khaina, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 z cechą
    oręża PRECYZYJNE UDERZENIE.`,
    ],
    10: [
      "11 OSTRZE PANA WĘŻY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Wieszczka Khaina władająca Ostrzem Pana Węży otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Pana Węży - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 POŚWIĘCENIE",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Wieszczka Khaina przyzywa bluźnierczą moc Dhar, którą oplata dowolny sprzymierzony
    model bohatera lub stronnika znajdujący się w odległości do 12”. Czar może zostać
    rzucony na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem
    działał na modele na podstawkach 40x40 mm i większych), również związany walką
    wręcz. Dopóki zaklęcie 'pozostaje w grze' ofiara zaklęcia zamienia się w żywą bombę,
    która na życzenie MAGA eksploduje w wybranej przez gracza fazie strzelania. Model,
    który eksplodował zostaje automatycznie Wyłączony z akcji!, a następnie należy użyć 3”
    okrągłego wzornika, którego środek należy umieścić w miejscu eksplozji ofiary zaklęcia.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+. Objęte
    działaniem zaklęcia modele otrzymują trafienie o SILE K6 z cechą oręża PRECYZYJNE
    UDERZENIE.`,
    ],
  },
  "Magia Ognistej Paszczy": {
    1: [
      "1-2 OGNISTA PASZCZA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Ogniobrzuchego, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele objęte działaniem zaklęcia wykonują rzut na zranienie 3K6
    odrzucając kostkę z najniższym wynikiem.`,
    ],
    2: [
      "3 WROTA TRZEWIODOŁU",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy Wrota Trzewiodołu łączące dwa punkty na stole, które
    muszą znajdować się w odległości do 18” od MAGA. Wrota należy traktować jak
    ‘zwykłe’ drzwi, przez które model może wykonać ruch jak w fazie ruchu, który może być
    również ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z
    wyjątkiem tego, że nie można próbować przejąć szarży modelu, który przekroczył Wrota
    Trzewiodołu).`,
    ],
    3: [
      "4 PŁOMIENNA KLĄTWA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Płomienna klątwa ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Ogniobrzuchy musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy staje się ŁATWOPALNA.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    4: [
      "5 OGNISTA PLWOCINA",
      "RZUCONY NA 7+",
      `Ognista Plwocina jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 SKÓRA NOSOROŻNIKA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Ogniobrzuchego, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza (do maksymalnego
    poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają PANCERZA.`,
    ],
    6: [
      "7 KLĄTWA OGNISTEJ PASZCZY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Ognistej Paszczy ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Ogniobrzuchy musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 4” mogą zostać obrane na cel czarów oraz ataków bronią dystansową, które
    podlegają zasadzie specjalnej PŁONĄCY ATAK nawet, jeśli atakujący nie widzi celu lub
    przeklęty model Ukrywa się.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE TRZEWIODOŁU",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 ŻAR I ZNISZCZENIE!",
      "RZUCONY NA 11+",
      `Żar i Zniszczenie! jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 GOREJĄCY NABRZUSZNIK",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Ogniobrzuchego, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PŁONĄCY ATAK.`,
    ],
    10: [
      "11 ŁAMIGNAT",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Ogniobrzuchy władający Łamignatem otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Łamignata - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 KLĄTWA TRZEWIODOŁU",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Klątwa Trzewiodołu ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Ogniobrzuchy musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli zostanie
    trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Magia Demonów": {
    1: [
      "1-2 MGŁA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie modele (wrogie i sprzymierzone)
    znajdujące się w odległości do 12" od rzucającego zaklęcie Fimira, również takie, które
    walczą wręcz. Dopóki zaklęcie 'pozostaje w grze' objęte działaniem zaklęcia modele
    zostają spowite MGŁĄ (zobacz ROZDZIAŁ XII: SCENARIUSZE paragraf POGODA W
    STARYM ŚWIECIE).`,
    ],
    2: [
      "3 PIEKIELNY WRZASK",
      "RZUCONY NA 8+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Modele objęte działaniem zaklęcia
    muszą wykonać test CP. Nieudany test oznacza, że modele Uciekają!. Zaklęcie nie
    działa na istoty podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 POCISK ZAGŁADY",
      "RZUCONY NA 7+",
      `Pocisk Zagłady jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża ZATRUTY ATAK.`,
    ],
    5: [
      "6 PANDEMONIUM",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie 'pozostaje w grze' wrogie modele bohaterów i stronników nie mogą
    używać jako podstawy testu wartości współczynnika CECHY PRZYWÓDCZE swojego
    DOWÓDCY. Należy zauważyć, że stronnicy nie mogą korzystać także z żadnych
    modyfikatorów oraz przerzutów testów CP wynikających z umiejętności i zasad
    specjalnych bohaterów. Ponadto, wrogie modele MAGÓW odczuwają PRZEKLEŃSTWO
    TZEENTCHA za każdym razem gdy podczas próby rzucenia zaklęcia wypadną dwa lub
    więcej naturalne dublety.`,
    ],
    6: [
      "7 KLĄTWA MROKU",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Mroku ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że czarnoksiężnik Fimirów musi
    widzieć swój cel). Dopóki zaklęcie 'pozostaje w grze' wszystkie trafienia zadane ofierze
    klątwy oraz wszystkim sprzymierzonym z postacią modelom w odległości do 6”
    podlegają zasadzie specjalnej ZATRUTY ATAK.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 DECH ŚMIERCI",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża ZATRUTY ATAK.`,
    ],
    8: [
      "9 OKO CIEMNOŚCI",
      "RZUCONY NA 11+",
      `Oko Ciemności jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża ZATRUTY ATAK.`,
    ],
    9: [
      "10 ZBROJA DEMONA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    rzucającego zaklęcie Fimira, na początku fazy walki wręcz otrzymują jedno trafienie o SILE
    4 z cechą oręża ZATRUTY ATAK.`,
    ],
    10: [
      "11 ŻĄDŁO DEMONA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, rzucający zaklęcie Fimir władający Żądłem Demona otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Żądła Demona - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 KLĄTWA FATUM",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Klątwa Fatum ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że czarnoksiężnik Fimirów musi widzieć swój cel). Dopóki
    zaklęcie 'pozostaje w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli
    zostanie trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.
    P
    NA BAGNACH GDZIE MROK GĘSTEJ MGŁY
    SEN W PRZERAŹLIWY KOSZMAR ZMIENIA ZŁY
    ŻYJĄ PRZEKLĘTE DEMONY O OKU JEDNYM
    ZŁOWIESZCZYM I ŚWIATŁOWSTRĘTNYM`,
    ],
  },
  "Dziedzina Chaosu Niepodzielonego": {
    1: [
      "1-2 CIĘTA RIPOSTA",
      "RZUCONY NA 6+",
      `Czar ma zasięg 12” i po udanym rzuceniu może zostać skierowany na pojedynczy
    model przeciwnika, także związany walką wręcz (wybrany przez kierującego MAGIEM
    gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi widzieć swój
    cel). Objęty działaniem zaklęcia model musi wykonać test WT. Nieudany test oznacza,
    że model traci 1 punkt ŻW bez możliwości skorzystania z Ochrony Pancerza.
    Należy zauważyć, że zaklęcie może zostać także skierowane na pojedynczy model
    sprzymierzeńca wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który został naznaczony Piętnem
    Chaosu Niepodzielonego. Model taki automatycznie zdaje test WT, ponadto natychmiast
    odzyskuje wszystkie utracone punkty ŻYWOTNOŚCI, a jeśli model był Powalony na
    ziemię! lub Oszołomiony!, to natychmiast wstaje i kontynuuje turę normalnie.`,
    ],
    2: [
      "3 WIZJA MĘKI",
      "RZUCONY NA 6+",
      `Wizja Męki ma zasięg 18” i po udanym rzuceniu może zostać skierowana na pojedynczy
    model przeciwnika, także związany walką wręcz (wybrany przez kierującego MAGIEM
    gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik musi widzieć swój cel).
    Ofiara zaklęcia musi wykonać test CP. Nieudany test oznacza, że model zostaje
    Powalony na ziemię!.
    Czar nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 PALĄCA KREW",
      "RZUCONY NA 7+",
      `Paląca Krew jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża OGŁUSZAJĄCY.`,
    ],
    5: [
      "6 WEZWANIE MOCY",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony lub wrogi model
    bohatera lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można
    rzucić na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał
    na modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Następnie należy wykonać rzut K6, aby określić jaki wpływ na model miała
    energia Dhar. Wynik 1 oznacza, że moc zaklęcia zatruwa model, a ofiara zostaje
    natychmiast Wyłączona z akcji!; wynik 2-5 oznacza, że dopóki zaklęcie 'pozostaje w grze'
    wartość jednego ze współczynników, wybranego przez gracza kontrolującego model
    zostaje zwiększona o +1; zaś 6 oznacza, że dopóki zaklęcie 'pozostaje w grze' wartość
    wszystkich współczynników zostaje zwiększona o +1.
    Należy zauważyć, że dzięki mocy zaklęcia wartość współczynników może zostać
    zwiększona ponad rasowe maksimum (aż do maksymalnej wartości 10 punktów).`,
    ],
    6: [
      "7 KLĄTWA DUCHA CHAOSU",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Ducha Chaosu ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik musi widzieć swój
    cel). Dopóki zaklęcie 'pozostaje w grze' wszystkie trafienia zadane ofierze klątwy oraz
    wszystkim sprzymierzonym z postacią modelom w odległości do 6” podlegają zasadzie
    specjalnej OGŁUSZAJĄCY.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 SŁOWO BÓLU",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża OGŁUSZAJĄCY.`,
    ],
    8: [
      "9 ŁAŃCUCHY MĘKI",
      "RZUCONY NA 11+",
      `Łańcuchy Męki są niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża OGŁUSZAJĄCY.`,
    ],
    9: [
      "10 ZBROJA DUCHA CHAOSU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarnoksiężnika, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 z cechą
    oręża OGŁUSZAJĄCY.`,
    ],
    10: [
      "11 OSTRZE DUCHA CHAOSU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża OGŁUSZAJĄCY oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Czarnoksiężnik władająca Ostrzem Ducha Chaosu otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Ducha Chaosu - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 POŚWIECENIE",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Czarnoksiężnik przyzywa bluźnierczą moc Dhar, którą oplata dowolny sprzymierzony
    model bohatera lub stronnika znajdujący się w odległości do 12”. Czar może zostać
    rzucony na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem
    działał na modele na podstawkach 40x40 mm i większych), również związany walką
    wręcz. Dopóki zaklęcie 'pozostaje w grze' ofiara zaklęcia zamienia się w żywą bombę,
    która na życzenie MAGA eksploduje w wybranej przez gracza fazie strzelania. Model,
    który eksplodował zostaje automatycznie Wyłączony z akcji!, a następnie należy użyć 3”
    okrągłego wzornika, którego środek należy umieścić w miejscu eksplozji ofiary zaklęcia.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+. Objęte
    działaniem zaklęcia modele otrzymują trafienie o SILE K6 z cechą oręża OGŁUSZAJĄCY.`,
    ],
  },
  "Dziedzina Nurgla": {
    1: [
      "1-2 WYBORNE WRZODY",
      "RZUCONY NA 6+",
      `Czar ma zasięg 12” i po udanym rzuceniu może zostać skierowany na pojedynczy
    model przeciwnika, także związany walką wręcz (wybrany przez kierującego MAGIEM
    gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Nurgla musi widzieć swój
    cel). Objęty działaniem zaklęcia model musi wykonać test WT. Nieudany test oznacza,
    że model traci 1 punkt ŻW bez możliwości skorzystania z Ochrony Pancerza.
    Należy zauważyć, że zaklęcie może zostać także skierowane na pojedynczy model
    sprzymierzeńca wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który został naznaczony Piętnem
    Nurgla. Model taki automatycznie zdaje test WT, ponadto natychmiast odzyskuje
    wszystkie utracone punkty ŻYWOTNOŚCI, a jeśli model był Powalony na ziemię! lub
    Oszołomiony!, to natychmiast wstaje i kontynuuje turę normalnie.`,
    ],
    2: [
      "3 DOSKONAŁA LIMFA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz. Do
    początku następnej fazy magii MAGA, ofiara zaklęcia podlega zasadzie specjalnej
    REGENERACJA.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 WYŚMIENITE CZYRAKI",
      "RZUCONY NA 7+",
      `Wyśmienite Czyraki są magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE K6 bez możliwości skorzystania
    z Ochrony Pancerza.`,
    ],
    5: [
      "6 NAWAŁNICA ZARAZY",
      "RZUCONY NA 9+",
      `Nawałnica Zarazy jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele muszą wykonać test WT.
    Nieudany test oznacza, że model traci 1 punkt ŻW bez możliwości skorzystania z
    Ochrony Pancerza.
    Należy zauważyć, że zaklęcie może zostać także skierowane na model
    sprzymierzeńca wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który został naznaczony Piętnem
    Nurgla. Model taki automatycznie zdaje test WT, ponadto natychmiast odzyskuje
    wszystkie utracone punkty ŻYWOTNOŚCI, a jeśli model był Powalony na ziemię! lub
    Oszołomiony!, to natychmiast wstaje i kontynuuje turę normalnie.`,
    ],
    6: [
      "7 KLĄTWA NURGLA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Nurgla ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Nurgla musi
    widzieć swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie
    sprzymierzone z postacią modele w odległości do 6” nie mogą biegać, ponadto wartość
    współczynnika SZ zostaje zmniejszona o połowę (ewentualne ułamki należy zaokrąglić
    w górę). Modele podlegające zasadzie specjalnej LOT, nie mogą latać i biegać, jednak wartość
    ich współczynnika SZ pozostaje bez zmian.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 WIATR ZARAZY",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    8: [
      "9 PRZEDNIA ZGNILIZNA",
      "RZUCONY NA 11+",
      `Przednia Zgnilizna jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 ZBROJA NURGLA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarnoksiężnika Nurgla, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6
    bez możliwości skorzystania z Ochrony Pancerza`,
    ],
    10: [
      "11 OSTRZE NURGLA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Czarnoksiężnik Chaosu władająca Ostrzem Nurgla otrzymuje dodatkowy
    +1 ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Nurgla - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 PRZEŚLICZNY TRĄD",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Prześliczny Trąd ma zasięg 18” i po udanym rzuceniu może zostać skierowany na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Nurgla musi widzieć
    swój cel). Po udanym rzuceniu zaklęcia należy umieścić obok ofiary klątwy sześciościenną
    kostkę, tak aby wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku
    każdej kolejnej fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1
    większy. Wynik na kostce oznacza ujemny modyfikator do współczynników S i WT jaki
    otrzymuje ofiara klątwy. Jeśli w wyniku działania czaru wartość współczynników zostanie
    obniżona do 0, model zostaje natychmiast Wyłączony z akcji!.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Dziedzina Slaanesha": {
    1: [
      "1-2 BŁOGA AGONIA",
      "RZUCONY NA 6+",
      `Czar ma zasięg 12” i po udanym rzuceniu może zostać skierowany na pojedynczy
    model przeciwnika, także związany walką wręcz (wybrany przez kierującego MAGIEM
    gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi widzieć swój
    cel). Objęty działaniem zaklęcia model musi wykonać test WT. Nieudany test oznacza,
    że model traci 1 punkt ŻW bez możliwości skorzystania z Ochrony Pancerza.
    Należy zauważyć, że zaklęcie może zostać także skierowane na pojedynczy model
    sprzymierzeńca wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który został naznaczony Piętnem
    Slaanesha. Model taki automatycznie zdaje test WT, ponadto natychmiast odzyskuje
    wszystkie utracone punkty ŻYWOTNOŚCI, a jeśli model był Powalony na ziemię! lub
    Oszołomiony!, to natychmiast wstaje i kontynuuje turę normalnie.`,
    ],
    2: [
      "3 KLĄTWA TAŃCA ROZKOSZY",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Klątwa Tańca Rozkoszy ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi widzieć swój cel). Dopóki
    zaklęcie 'pozostaje w grze' ofiara klątwy w ramach ruchów przymusowych w czasie
    rozgrywania fazy ruchu porusza się o K3” w losowo określonym kierunku (w przypadku
    gdy na Kostce Rozrzutu wypadnie wynik TRAFIENIE!, kierunek ruchu wybiera kierujący
    MAGIEM gracz). Jeżeli ruch oznaczałby wejście w kontakt z innym modelem, należy
    zatrzymać dotkniętą działaniem zaklęcia postać 1” od modelu.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 CUDOWNE MĘKI",
      "RZUCONY NA 7+",
      `Cudowne Męki są magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    5: [
      "6 FANTASMAGORIA",
      "RZUCANY NA 10+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie 'pozostaje w grze', wszystkie wrogie modele znajdujące się na stole
    przeprowadzając test oparty na współczynniku CP wykonują rzut 3K6 odrzucając
    kostkę z najniższym wynikiem.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.`,
    ],
    6: [
      "7 KLĄTWA SLAANESHA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Slaanesha ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi
    widzieć swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie
    sprzymierzone z postacią modele w odległości do 6” podlegają zasadzie specjalnej
    GŁUPOTA. Ponadto, model przeprowadzając test oparty na współczynniku CP
    wykonuje rzut 3K6 odrzucając kostkę z najniższym wynikiem. Zaklęcie nie działa na
    modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 PIEKIELNY KRZYK",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    8: [
      "9 PIESZCZOTA SLAANESHA",
      "RZUCONY NA 11+",
      `Pieszczota Slaanesha jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    9: [
      "10 ZBROJA SLAANESHA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarnoksiężnika Slaanesha, na początku fazy walki wręcz otrzymują jedno trafienie o SILE
    K6 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    10: [
      "11 OSTRZE SLAANESHA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRECYZYJNE UDERZENIE oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Czarnoksiężnik Chaosu władająca Ostrzem Slaanesha otrzymuje
    dodatkowy +1 ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem
    może korzystać tylko z Ostrza Slaanesha - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 ZACHWYCAJĄCE SPAZMY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Zachwycające Spazmy mają zasięg 18”. Po udanym rzuceniu zaklęcia należy użyć 3”
    okrągłego wzornika i przykryć nim wybrany na cel model przeciwnika. Wszystkie
    modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+. Dopóki
    zaklęcie ‘pozostaje w grze’ objęte działaniem klątwy modele nie mogą wykonać żadnego
    ruchu, rzucać zaklęć oraz strzelać. Ponadto, wszystkie ATAKI wymierzone w poddane
    działaniu zaklęcia modele trafiają automatycznie (model traktowany jest tak, jakby
    wartość współczynnika WALKA WRĘCZ wynosiła 0). Zaklęcie nie działa na modele
    podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Dziedzina Tzeentcha": {
    1: [
      "1-2 WEWNĘTRZNY OGIEŃ",
      "RZUCONY NA 6+",
      `Czar ma zasięg 12” i po udanym rzuceniu może zostać skierowany na pojedynczy
    model przeciwnika, także związany walką wręcz (wybrany przez kierującego MAGIEM
    gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi widzieć swój
    cel). Objęty działaniem zaklęcia model musi wykonać test WT. Nieudany test oznacza,
    że model traci 1 punkt ŻW bez możliwości skorzystania z Ochrony Pancerza.
    Należy zauważyć, że zaklęcie może zostać także skierowane na pojedynczy model
    sprzymierzeńca wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), który został naznaczony Piętnem
    Tzeentcha. Model taki automatycznie zdaje test WT, ponadto natychmiast odzyskuje
    wszystkie utracone punkty ŻYWOTNOŚCI, a jeśli model był Powalony na ziemię! lub
    Oszołomiony!, to natychmiast wstaje i kontynuuje turę normalnie.`,
    ],
    2: [
      "3 POMARAŃCZOWY OGIEŃ",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz. Do
    początku następnej fazy magii MAGA, ofiara zaklęcia może przerzucić wszystkie
    nieudane testy na trafienie, zranienie oraz Ochronę Pancerza i Ochronę Magiczną. Wynik
    drugiego rzutu jest ostateczny.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 BŁĘKITNY OGIEŃ",
      "RZUCONY NA 7+",
      `Błękitny Ogień jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 PANDEMONIUM",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie 'pozostaje w grze' wrogie modele bohaterów i stronników nie mogą
    używać jako podstawy testu wartość współczynnika CECHY PRZYWÓDCZE swojego
    DOWÓDCY. Należy zauważyć, że stronnicy nie mogą korzystać także z żadnych
    modyfikatorów oraz przerzutów testów CP wynikających z umiejętności i zasad
    specjalnych bohaterów. Ponadto, wrogie modele MAGÓW odczuwają PRZEKLEŃSTWO
    TZEENTCHA za każdym razem gdy podczas próby rzucenia zaklęcia wypadną dwa lub
    więcej naturalne dublety.`,
    ],
    6: [
      "7 KLĄTWA TZEENTCHA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Tzeentcha ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik Chaosu musi
    widzieć swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie
    sprzymierzone z postacią modele w odległości do 6” mogą zostać obrane na cel czarów
    oraz ataków bronią dystansową, które podlegają zasadzie specjalnej PŁONĄCY ATAK nawet,
    jeśli atakujący nie widzi celu lub przeklęty model Ukrywa się.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 OGNISTE TCHNIENIE",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 RÓŻOWY OGIEŃ",
      "RZUCONY NA 11+",
      `Różowy Ogień jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 ZBROJA TZEENTCHA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarnoksiężnika Chaosu, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6
    z cechą oręża PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE TZEENTCHA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Czarnoksiężnik Chaosu władający Ostrzem Tzeentcha otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Tzeentcha - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 POKUSA TZEENTCHA",
      "RZUCONY NA 12+",
      `Pokusa Tzeentcha ma zasięg 24”. Po udanym rzuceniu zaklęcia należy użyć 3” okrągłego
    wzornika i przykryć nim wybrany na cel model przeciwnika. Wszystkie modele (wrogie
    i sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele
    zadaje sobie jedno automatyczne trafienie losowo określoną bronią do walki wręcz. Rzut
    na zranienie wykonuje się z SIŁĄ objętego działaniem klątwy modelu.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Dziedzina Hashuta": {
    1: [
      "1-2 WOLA HASHUTA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Czarnoksiężnika, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele objęte działaniem zaklęcia wykonują rzut na zranienie
    3K6 odrzucając kostkę z najniższym wynikiem.`,
    ],
    2: [
      "3 BYCZY PĘD",
      "RZUCONY NA 7+",
      `Każdy sprzymierzony model bohatera lub stronnika znajdujący się w odległości do 8" od
    Czarnoksiężnika wykonuje niezwłocznie ruch o K6" (należy wykonać oddzielny rzut dla
    każdego modelu) w kierunku najbliższego widocznego wroga, najkrótszą możliwą
    drogą, stosując zwykłe kary za teren – jeśli objęty działaniem zaklęcia model nie widzi
    żadnego wroga, porusza się dokładnie o K6” na wprost. Jeżeli ruch taki prowadzi do
    kontaktu z wrogiem, to jest to równoznaczne z szarżą – wykonujący ruch model nie
    musi przeprowadzać żadnych testów PSYCHOLOGICZNYCH, które obowiązywały go
    podczas zwykłej szarży. Zaatakowana w ten sposób postać może wybrać jako reakcję na
    szarżę jedynie trzymać pozycje bądź Uciekać!. Zaklęcie nie działa na modele, które Uciekają!.`,
    ],
    3: [
      "4 SKRZYDŁA ZAGANA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 CZARNY OGIEŃ",
      "RZUCONY NA 7+",
      `Czarny Ogień jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 WEZWANIE MOCY",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony lub wrogi model
    bohatera lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Następnie należy wykonać rzut K6, aby określić jaki wpływ na model miała
    energia Dhar. Wynik 1 oznacza, że moc zaklęcia zatruwa model, a ofiara zostaje
    natychmiast Wyłączona z akcji!; wynik 2-5 oznacza, że dopóki zaklęcie 'pozostaje w grze'
    wartość jednego ze współczynników, wybranego przez gracza kontrolującego model
    zostaje zwiększona o +1; zaś 6 oznacza, że dopóki zaklęcie 'pozostaje w grze' wartość
    wszystkich współczynników zostaje zwiększona o +1.
    Należy zauważyć, że dzięki mocy zaklęcia wartość współczynników może zostać
    zwiększona ponad rasowe maksimum (aż do maksymalnej wartości 10 punktów).`,
    ],
    6: [
      "7 KLĄTWA HASHUTA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Hashuta ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Czarnoksiężnik musi widzieć swój
    cel). Dopóki zaklęcie 'pozostaje w grze' wszystkie trafienia zadane ofierze klątwy oraz
    wszystkim sprzymierzonym z postacią modelom w odległości do 4” podlegają zasadzie
    specjalnej PŁONĄCY ATAK.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE OJCA CIEMNOŚCI",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 OGIEŃ HASHUTA",
      "RZUCONY NA 11+",
      `Ogień Hashuta jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    9: [
      "10 ZBROJA HASHUTA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarnoksiężnika Krasnoludów Chaosu, na początku fazy walki wręcz otrzymują jedno
    trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
    10: [
      "11 OSTRZE HASHUTA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Czarnoksiężnik władający Ostrzem Hashuta otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Hashuta - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 POŚWIECENIE",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Czarnoksiężnik przyzywa bluźnierczą moc Dhar, którą oplata dowolny sprzymierzony
    model bohatera lub stronnika znajdujący się w odległości do 12”. Czar może zostać
    rzucony na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem
    działał na modele na podstawkach 40x40 mm i większych), również związany walką
    wręcz. Dopóki zaklęcie 'pozostaje w grze' ofiara zaklęcia zamienia się w żywą bombę,
    która na życzenie MAGA eksploduje w wybranej przez gracza fazie strzelania. Model,
    który eksplodował zostaje automatycznie Wyłączony z akcji!, a następnie należy użyć 3”
    okrągłego wzornika, którego środek należy umieścić w miejscu eksplozji ofiary zaklęcia.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+. Objęte
    działaniem zaklęcia modele otrzymują trafienie o SILE K6 z cechą oręża PŁONĄCY ATAK.`,
    ],
  },
  "Dziedzina Dziczy": {
    1: [
      "1-2 WŁADCA BESTII",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
    PRZYWOŁANIE (Wilczarz Chaosu).`,
    ],
    2: [
      "3 ZWIERZĘCY PĘD",
      "RZUCONY NA 7+",
      `Każdy sprzymierzony model bohatera lub stronnika znajdujący się w odległości do 12"
    od Szamana Zwierzoludzi wykonuje niezwłocznie ruch o K6" (należy wykonać
    oddzielny rzut dla każdego modelu) w kierunku najbliższego widocznego wroga,
    najkrótszą możliwą drogą, stosując zwykłe kary za teren – jeśli objęty działaniem
    zaklęcia model nie widzi żadnego wroga, porusza się dokładnie o K6” na wprost. Jeżeli
    ruch taki prowadzi do kontaktu z wrogiem, to jest to równoznaczne z szarżą –
    wykonujący ruch model nie musi przeprowadzać żadnych testów
    PSYCHOLOGICZNYCH, które obowiązywały go podczas zwykłej szarży. Zaatakowana
    w ten sposób postać może wybrać jako reakcję na szarżę jedynie trzymać pozycje bądź
    Uciekać!. Zaklęcie nie działa na modele, które Uciekają!.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 PLUGAWY RÓJ",
      "RZUCONY NA 7+",
      `Plugawy Rój jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża OGŁUSZAJĄCY bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    5: [
      "6 SKÓRA RAZORGORA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 12" od Szamana Zwierzoludzi, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza (do
    maksymalnego poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają PANCERZA.`,
    ],
    6: [
      "7 KLĄTWA DZICZY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Dziczy ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Szaman Zwierzoludzi musi widzieć
    swój cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone
    z postacią modele w odległości do 6” traktowane są tak jakby poruszały się po terenie
    bardzo trudnym i terenie niebezpiecznym.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE ENTROPII",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża OGŁUSZAJĄCY bez możliwości skorzystania z
    Ochrony Pancerza.`,
    ],
    8: [
      "9 CHMARA INSEKTÓW",
      "RZUCONY NA 11+",
      `Chmara Insektów jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża OGŁUSZAJĄCY bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 ZBROJA DZICZY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na K6+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Szamana Zwierzoludzi, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 z
    cechą oręża OGŁUSZAJĄCY bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE RYKOWCA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża OGŁUSZAJĄCY oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Szaman Zwierzoludzi władająca Ostrzem Rykowca otrzymuje dodatkowy +1
    ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Ostrza Rykowca - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 GNIEW GHOROKA",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Czar może zostać rzucony
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym Minotaur. Uzyskuje zdolność broń
    naturalna, +3 ATAKI, +2 do SIŁY oraz +1 do WT. Model pozostający pod wpływem
    zaklęcia, nie może używać oręża, tarczy & pancerza.`,
    ],
  },
  "Dziedzina Nekromancji": {
    1: [
      "1-2 INWOKACJA NEHEK",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
    PRZYWOŁANIE (Zombie).`,
    ],
    2: [
      "3 MROK I ZAGŁADA!",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Mrok i Zagłada! ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Nekromanta musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy przeprowadzając test oparty na współczynniku CP
    wykonuje rzut 3K6 odrzucając kostkę z najniższym wynikiem.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.`,
    ],
    4: [
      "5 ETERYCZNA ISKRA",
      "RZUCONY NA 7+",
      `Eteryczna Iskra jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 bez możliwości skorzystania z
    Ochrony Pancerza.`,
    ],
    5: [
      "6 ZEW VANHELA",
      "RZUCONY NA 8+",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Nekromanty, które podlegają zasadzie specjalnej NIEUMARŁY. Objęte
    działaniem czaru modele mogą wykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który odpowiedział na Zew Vanhela).`,
    ],
    6: [
      "7 KLĄTWA STAROŚCI",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika znajdujący się w
    odległości do 18" i w polu widzenia MAGA. Po udanym rzuceniu zaklęcia należy umieścić
    obok ofiary czaru sześciościenną kostkę, tak aby wskazywała wynik ‘6’. Dopóki zaklęcie
    'pozostaje w grze', na początku każdej kolejnej fazy magii Nekromanty należy obracać
    kostkę tak, by wskazywała wynik o 1 mniejszy. Następnie należy wykonać rzut K6.
    Jeżeli wynik rzutu jest równy lub wyższy od wartości wskazywanej przez umieszczoną
    obok ofiary zaklęcia kostkę, to model zostaje natychmiast Wyłączony z akcji!.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 WSKRZESZENIE",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny sprzymierzony model stronnika podlegający
    zasadzie specjalnej NIEUMARŁY, który został Wyłączony z akcji!, a który znajduje się w polu
    widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć wzornika płomienia w ten
    sposób, że cieńszy jego koniec dotyka podstawki MAGA, a szeroki przykrywa wybrany
    na cel sprzymierzony model stronnika, który został Wyłączony z akcji!. Wszystkie
    sprzymierzone modele, których podstawki są całkowicie przykryte wzornikiem, zostają
    objęte działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Za każdy objęty działaniem zaklęcia
    sprzymierzony model stronnika, który został Wyłączony z akcji! należy wykonać rzut K6.
    Wynik 4+ oznacza, że model natychmiast powstaje z martwych i kontynuuje turę
    normalnie, od momentu powstania model należy traktować tak, jakby wciąż posiadał 1
    punkt ŻW. Wskrzeszeni NIEUMARLI, jeśli przetrwają potyczkę rozpadają się w pył po
    zakończeniu rozgrywki, a w czasie sekwencji po potyczce dla każdego takiego modelu
    stronnika należy wykonać rzut na TABELĘ POWAŻNYCH OBRAŻEŃ.`,
    ],
    8: [
      "9 CZEREP TRUPA",
      "RZUCONY NA 11+",
      `Czerep Trupa jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 MARMUROWA SKÓRA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Nekromanty, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE TRUPA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Nekromanta władający Ostrzem Trupa otrzymuje dodatkowy +1 ATAK,
    a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Trupa - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 CIELESNA EKSPLOZJA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG przyzywa bluźnierczą moc Dhar, którą oplata dowolny sprzymierzony
    NIEUMARŁY model bohatera lub stronnika znajdujący się w odległości do 12”. Czar może
    zostać rzucony na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie
    zatem działał na modele na podstawkach 40x40 mm i większych), również związany
    walką wręcz. Dopóki zaklęcie 'pozostaje w grze' ofiara zaklęcia zamienia się w nieżywą
    bombę, która na życzenie MAGA eksploduje w wybranej przez gracza fazie strzelania.
    Model, który eksplodował zostaje automatycznie Wyłączony z akcji!, a następnie należy
    użyć 3” okrągłego wzornika, którego środek należy umieścić w miejscu eksplozji ofiary
    zaklęcia. Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie
    przykryte wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele,
    których podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+.
    Objęte działaniem zaklęcia modele otrzymują trafienie o SILE 4 bez możliwości
    skorzystania z Ochrony Pancerza.`,
    ],
  },
  "Dziedzina Nehekary": {
    1: [
      "1-2 INKANTACJA KHEPRY",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
    PRZYWOŁANIE (Rój).`,
    ],
    2: [
      "3 INKANTACJA USIRIANA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które
    muszą znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak
    ‘zwykłe’ drzwi, przez które modelmożewykonać ruch jak w fazie ruchu, który może być
    również ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z
    wyjątkiem tego, że nie można próbować przejąć szarżymodelu, który przekroczył wrota
    przywołane Inkantacją Usiriana).
    `,
    ],
    3: [
      "4 INKANTACJA PTRY",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 INKANTACJA PHAKTHA",
      "RZUCONY NA 7+",
      `Inkantacja Phaktha jest magicznym pociskiem o zasięgu 24”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 bez możliwości skorzystania z
    Ochrony Pancerza.
    `,
    ],
    5: [
      "6 INKANTACJA KHSARA",
      "RZUCONY NA 8+",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Nekromanty, które podlegają zasadzie specjalnej NIEUMARŁY. Objęte
    działaniem czaru modele mogą wykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który wykonał ruch dzięki Inkantacji
    Khsara).`,
    ],
    6: [
      "7 INKANTACJA USEKPHA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika znajdujący się w
    odległości do 24" i w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy umieścić
    obok ofiary czaru sześciościenną kostkę, tak aby wskazywała wynik ‘6’. Dopóki zaklęcie
    'pozostaje w grze', na początku każdej kolejnej fazy magii Licza należy obracać kostkę
    tak, by wskazywała wynik o 1mniejszy. Następnie należy wykonać rzut K6. Jeżeli wynik
    rzutu jest równy lub wyższy od wartości wskazywanej przez umieszczoną obok ofiary
    zaklęcia kostkę, to model zostaje natychmiast Wyłączony z akcji!.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz`,
    ],
    7: [
      "8 INKANTACJA SAKHMETY",
      "RZUCONY NA 11+",
      `Zaklęcie może zostać rzucone na dowolny sprzymierzony model stronnika podlegający
    zasadzie specjalnej NIEUMARŁY, który został Wyłączony z akcji!, a który znajduje się w polu
    widzenia MAGA. Po udanym rzuceniu zaklęcia należy użyć wzornika płomienia w ten
    sposób, że cieńszy jego koniec dotyka podstawki MAGA, a szeroki przykrywa wybrany
    na cel sprzymierzony model stronnika, który został Wyłączony z akcji!. Wszystkie
    sprzymierzone modele, których podstawki są całkowicie przykryte wzornikiem, zostają
    objęte działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Za każdy objęty działaniem zaklęcia
    sprzymierzony model stronnika, który został Wyłączony z akcji! należy wykonać rzut K6.
    Wynik 4+ oznacza, że model natychmiast powstaje z martwych i kontynuuje turę
    normalnie, od momentu powstania model należy traktować tak, jakbywciąż posiadał 1
    punkt ŻW. Wskrzeszeni NIEUMARLI, jeśli przetrwają potyczkę rozpadają się w pył po
    zakończeniu rozgrywki, a w czasie sekwencji po potyczce dla każdego takiego modelu
    stronnika należy wykonać rzut na TABELĘ POWAŻNYCH OBRAŻEŃ`,
    ],
    8: [
      "9 INKANTACJA QU’APH",
      "RZUCONY NA 11+",
      `Inkantacja Qu’aph jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 bez możliwości skorzystania z Ochrony Pancerza.`,
    ],
    9: [
      "10 INKANTACJA NERU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Licza, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 bez możliwości
    skorzystania z Ochrony Pancerza.
    `,
    ],
    10: [
      "11 INKANTACJA DJAFA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Licz władający ostrzem Djafa otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z ostrzem Djafa - magicznego oręża nie można łączyć z inną bronią`,
    ],
    11: [
      "12 INKANTACJA SOKTHA",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Inkantacja Soktha ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Licz musi widzieć swój cel). Dopóki zaklęcie 'pozostaje
    w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli zostanie trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.
    `,
    ],
  },
  "Tradycja Skrytości": {
    1: [
      "1-2 ROZMYCIE POSTACI",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Dopóki zaklęcie 'pozostaje w grze' model wydaje się znajdować kilka kroków od
    swojej prawdziwej pozycji, a wszystkie ataki (zarówno w fazie strzelania jak i w fazie walki
    wręcz) wymierzone w poddany działaniu zaklęcia model wykonywane są z karą -1 do
    rzutu na trafienie.
    `,
    ],
    2: [
      "3 SPACZPORTAL",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które modelmożewykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Spaczportal).`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 ODDECH ŚMIERCI",
      "RZUCONY NA 7+",
      `Czarny Ogień jest magicznym pociskiemo zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 z cechą oręża SKRYTOBÓJCZY.`,
    ],
    5: [
      "6 WIDMOWY MARSZ",
      "RZUCONY NA 9+",
      `Czar oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się w
    odległości do 12" od Czarownika. Objęte działaniem czaru modele mogą wykonać ruch
    jak w fazie ruchu, który może być również ruchem szarży (szarża ta podlegać będzie
    wszystkim zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży
    modelu, który wykonał Widmowy Ruch).`,
    ],
    6: [
      "7 KLĄTWA SKRYTOBÓJCY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Skrytobójcy ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Czarownik musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w
    odległości do 6” mogą zostać obrane na cel czarów typu magiczny pocisk oraz ataków
    bronią dystansową nawet, jeśli atakujący nie widzi celu lub przeklęty model Ukrywa się.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE ZNISZCZENIA",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża SKRYTOBÓJCZY.`,
    ],
    8: [
      "9 POCISK ZAGŁADY",
      "RZUCONY NA 11+",
      `Tnij-Rąb jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po udanym
    rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany na cel
    model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których podstawki są
    całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te
    modele, których podstawki są częściowo przykryte, dostają się pod działanie zaklęcia
    na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE K6 z cechą oręża
    SKRYTOBÓJCZY.`,
    ],
    9: [
      "10 ZBROJA SKRYTOBÓJCY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarownika, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 z cechą oręża
    SKRYTOBÓJCZY.`,
    ],
    10: [
      "11 OSTRZE SKRYTOBÓJCY",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Czarownikwładający Spaczostrzemotrzymuje dodatkowy +1 ATAK, a wszystkie
    ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko ze
    Spaczostrza - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 TARCZA SKRYTOBÓJCÓW",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 12" od Czarownika, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele pozostające w zasięgu działania zaklęcia otrzymują Magiczną
    Ochronę na 4+, ponadto wrogie postacie atakujące modele chronione Spacztarczą
    otrzymują modyfikator -1 do rzutu na trafienie.
    `,
    ],
  },
  "Tradycja Spaczmagii": {
    1: [
      "1-2 POTĘGA SPACZMAGII",
      "RZUCONY NA 6+",
      `Po udanym rzuceniu zaklęcia Potęga Spaczmagii, MAG uzyskuje natychmiast dodatkowe
    K3 Kostki Mocy. Kostki te dodawane są do tych, które pozostają w dyspozycji Szarego
    Proroka, ale należy trzymać je oddzielnie lub użyć kostek innego koloru. Dodatkowych
    kostek nie można używać do rozpraszania czarów pozostających w grze, ani w
    jakikolwiek sposób przechowywać ich z tury na turę. Za każdą niewykorzystaną na
    koniec fazy magii Kostkę Mocy MAG otrzymuje automatyczne trafienie o SILE K6.
    `,
    ],
    2: [
      "3 SPACZPORTAL",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które modelmożewykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Spaczportal).`,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 SPACZBŁYSKAWICA",
      "RZUCONY NA 7+",
      `Spaczbłyskawica to magiczny pocisk o zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 bez możliwości skorzystania z Ochrony
    Pancerza.
    `,
    ],
    5: [
      "6 SKÓRA SZCZUROGRA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 12" od Szarego Proroka, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza (do
    maksymalnego poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają PANCERZA.`,
    ],
    6: [
      "7 KLĄTWA NIEMOCY",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika znajdujący się w
    odległości do 18" i w polu widzenia MAGA. Dopóki zaklęcie 'pozostaje w grze' ofiara
    klątwy oraz wszystkie sprzymierzone z postacią modele w odległości do 6” muszą
    przerzucić wszystkie udane rzuty na trafienie i zranienie.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.
    `,
    ],
    7: [
      "8 TCHNIENIE ŚMIERCI",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 z cechą oręża PRZEBICIE PANCERZA.`,
    ],
    8: [
      "9 SPACZGWIAZDKI",
      "RZUCONY NA 11+",
      `Spaczgwiazdki są niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 z cechą oręża PRZEBICIE PANCERZA. `,
    ],
    9: [
      "10 SPACZZBROJA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarownika, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 z cechą oręża
    PRZEBICIE PANCERZA.
    `,
    ],
    10: [
      "11 SPACZOSTRZE",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PRZEBICIE PANCERZA oraz premia +3 do SIŁY materializuje się w dłoni
    MAGA. Ponadto, Czarownik władający Spaczostrzem otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    ze Spaczostrza - magicznego oręża nie można łączyć z inną bronią.
    `,
    ],
    11: [
      "12 SIŁA SZCZUROGRA",
      "RZUCONY NA 13+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Czar może zostać rzucony
    na PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym Szczurogr. Uzyskuje zdolność broń
    naturalna, +3 ATAKI, +2 do SIŁY oraz +1 do WT. Model pozostający pod wpływem
    zaklęcia, nie może używać oręża, tarczy & pancerza.`,
    ],
  },
  "Tradycja Zarazy": {
    1: [
      "1-2 WOLA ROGATEGO SZCZURA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi, również takie, które walczą
    wręcz. Dopóki zaklęcie 'pozostaje w grze' model objęty działaniem zaklęcia może
    przerzucić wszystkie nieudane rzuty na zranienie. Wynik drugiego rzutu jest ostateczny`,
    ],
    2: [
      "3 PLUGAWA WITALNOŚĆ",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz. Do
    początku następnej fazy magii MAGA, ofiara zaklęcia podlega zasadzie specjalnej
    REGENERACJA.
    `,
    ],
    3: [
      "4 WIEDŹMI LOT",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 CUCHNĄCE RANY",
      "RZUCONY NA 7+",
      `Cuchnące Rany są magicznym pociskiemo zasięgu 18”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE K6 bez możliwości skorzystania z Ochrony
    Pancerza.`,
    ],
    5: [
      "6 POTĘGA ROGATEGO SZCZURA",
      "RZUCONY NA 8+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 12" od Diakona Zarazy, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' broń objętych działaniem czaru modeli otrzymuje cechę oręża
    ZATRUTY ATAK.
    `,
    ],
    6: [
      "7 KLĄTWA ROGATEGO SZCZURA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Rogatego Szczurama zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Diakon Zarazy musi widzieć swój
    cel). Dopóki zaklęcie 'pozostaje w grze' ofiara klątwy oraz wszystkie sprzymierzone z
    postacią modele w odległości do 6” nie mogą biegać, ponadto wartość współczynnika
    SZ zostaje zmniejszona o połowę (ewentualne ułamki należy zaokrąglić w górę).
    Modele podlegające zasadzie specjalnej LOT, nie mogą latać i biegać, jednak wartość ich
    współczynnika SZ pozostaje bez zmian.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE ZARAZY",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE K6 bez możliwości skorzystania z Ochrony Pancerza.
    `,
    ],
    8: [
      "9 ODDECH ZGNILIZNY",
      "RZUCONY NA 11+",
      `Oddech Zgnilizny jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    K6 bez możliwości skorzystania z Ochrony Pancerza. `,
    ],
    9: [
      "10 ZBROJA ROGATEGO SZCZURA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Czarownika, na początku fazy walki wręcz otrzymują jedno trafienie o SILE K6 bez
    możliwości skorzystania z Ochrony Pancerza.`,
    ],
    10: [
      "11 OSTRZE ROGATEGO SZCZURA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Czarownikwładający Spaczostrzemotrzymuje dodatkowy +1 ATAK, a wszystkie
    ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko ze
    Spaczostrza - magicznego oręża nie można łączyć z inną bronią.
    `,
    ],
    11: [
      "12 KLĄTWA TRĄDU",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Klątwa Trądu ma zasięg 18” i po udanym rzuceniu może zostać skierowany na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Diakon Zarazy musi widzieć swój
    cel). Po udanym rzuceniu zaklęcia należy umieścić obok ofiary klątwy sześciościenną
    kostkę, tak aby wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku
    każdej kolejnej fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1
    większy. Wynik na kostce oznacza ujemny modyfikator do współczynników S i WT
    jaki otrzymuje ofiara klątwy. Jeśli w wyniku działania czaru wartość współczynników
    zostanie obniżona do 0, model zostaje natychmiast Wyłączony z akcji!.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz. `,
    ],
  },
  "Magia Małego Łooomotu!": {
    1: [
      "1-2 WŁADCA SQUIGÓW",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
    PRZYWOŁANIE (Squig).`,
    ],
    2: [
      "3 PRZESMYK MORKA",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które modelmożewykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Przesmyk Morka).`,
    ],
    3: [
      "4 RENKA MORKA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 WEJRZENIE GORKA",
      "RZUCONY NA 7+",
      `Wejrzenie Gorka jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PRECYZYJNE
    UDERZENIE.`,
    ],
    5: [
      "6 FANTASMAGORIA",
      "RZUCANY NA 10+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie 'pozostaje w grze', wszystkie wrogie modele znajdujące się na stole
    przeprowadzając test oparty na współczynniku CP wykonują rzut 3K6 odrzucając
    kostkę z najniższym wynikiem.
    Zaklęcie nie działa na modele podlegające zasadzie specjalnej NIEZŁOMNOŚĆ.
    `,
    ],
    6: [
      "7 KLONTWA GORKA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Zaklęcie może zostać rzucone na dowolny model przeciwnika znajdujący się w
    odległości do 18" i w polu widzenia MAGA. Dopóki zaklęcie 'pozostaje w grze' ofiara
    klątwy oraz wszystkie sprzymierzone z postacią modele w odległości do 6” muszą
    przerzucić wszystkie udane rzuty na trafienie i zranienie.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE GORKA",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PRECYZYJNE UDERZENIE.`,
    ],
    8: [
      "9 CZACHA DYMI",
      "RZUCONY NA 11+",
      `Czacha dymi jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PRECYZYJNE UDERZENIE. `,
    ],
    9: [
      "10 ZBROJA GORKA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Szamana, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    PRECYZYJNE UDERZENIE`,
    ],
    10: [
      "11 OSTRZE MORKA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Szamanwładający Ostrzem Morkaotrzymuje dodatkowy +1 ATAK, a wszystkie
    ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko z Ostrza
    Morka - magicznego oręża nie można łączyć z inną bronią.
    `,
    ],
    11: [
      "12 MORK CIEM WYBRAĆ",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Szaman Goblinów wzywa moc Morka, którą oplata dowolny sprzymierzony model
    bohatera lub stronnika znajdujący się w odległości do 12”. Czar może zostać rzucony na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Dopóki zaklęcie 'pozostaje w grze' ofiara zaklęcia zamienia się w żywą bombę, która na
    życzenie MAGA eksploduje w wybranej przez gracza fazie strzelania. Model, który
    eksplodował zostaje automatycznie Wyłączony z akcji!, a następnie należy użyć 3”
    okrągłego wzornika, którego środek należy umieścić w miejscu eksplozji ofiary zaklęcia.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+. Objęte
    działaniem zaklęcia modele otrzymują trafienie o SILE 4 z cechą oręża PRECYZYJNE
    UDERZENIE.`,
    ],
  },
  "Magia Dużego Łooomotu!": {
    1: [
      "1-2 NAOSZCZENIE REMBAKÓW",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. Moc zaklęcia oddziałuje na K3 sztuki,
    dzierżonego przez bohaterów lub stronników i wybranego przez gracza oręża. Do końca
    potyczki wszystkie rzuty na zranienie NAOSZCZONYMI REMBAKAMI wykonywane są z
    dodatnim modyfikatorem +1. Ponadto, jeśli broń nie posiadała takiej cechy wcześniej,
    to zyskuje cechę oręża PRZEBICIE PANCERZA. `,
    ],
    2: [
      "3 PRAĆ ICH",
      "RZUCONY NA 7+",
      `Każdy sprzymierzony model bohatera lub stronnika znajdujący się w odległości do 12"
    od Szamana wykonuje niezwłocznie ruch o K6" (należy wykonać oddzielny rzut dla
    każdego modelu) w kierunku najbliższego widocznego wroga, najkrótszą możliwą
    drogą, stosując zwykłe kary za teren – jeśli objęty działaniem zaklęcia model nie widzi
    żadnego wroga, porusza się dokładnie o K6” na wprost. Jeżeli ruch taki prowadzi do
    kontaktu z wrogiem, to jest to równoznaczne z szarżą – wykonujący ruch model nie
    musi przeprowadzać żadnych testów PSYCHOLOGICZNYCH, które obowiązywały go
    podczas zwykłej szarży. Zaatakowana w ten sposób postać może wybrać jako reakcję na
    szarżę jedynie trzymać pozycje bądź Uciekać!. Zaklęcie nie działa na modele, które Uciekają!.
    `,
    ],
    3: [
      "4 RENKA GORKA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 WEJRZENIE MORKA",
      "RZUCONY NA 7+",
      `Wejrzenie Morka jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża DRUZGOCZĄCY`,
    ],
    5: [
      "6 SKÓRA DZIKA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 12" od Szamana, również takie, które walczą wręcz. Dopóki zaklęcie
    'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza (do maksymalnego
    poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają PANCERZA.
    `,
    ],
    6: [
      "7 GORK NAPRAWIĆ",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Gork Naprawić ma zasięg 18” i po udanym rzuceniu może zostać skierowany na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Szaman musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze', każda 6 w rzutach na trafienie, zranienie, Ochronę Pancerza czy Magiczną
    Ochronę wykonanych przez ofiarę klątwy oraz wszystkie sprzymierzone z postacią
    modele w odległości do 6” uznana będzie za 1. Jeżeli pod wpływem zaklęcia znajdzie
    się MAG przeciwnika, każda 6, jaką uzyska w trakcie rzucania czarów uznawana będzie
    za 1i może doprowadzić do Przekleństwa Tzeentcha, a także będzie zapobiegać rzuceniu
    czarów z Nieodpartą Siłą (oprócz innych skutków, jakie może przynieść).
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE MORKA",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża DRUZGOCZĄCY.
    `,
    ],
    8: [
      "9 Z BYKA GO",
      "RZUCONY NA 11+",
      `Zaklęcie Z byka go jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża DRUZGOCZĄCY`,
    ],
    9: [
      "10 ZBROJA MORKA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Szamana, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą oręża
    DRUZGOCZĄCY.
    `,
    ],
    10: [
      "11 OSTRZE GORKA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża DRUZGOCZĄCY oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Szamanwładający Ostrzem Gorka otrzymuje dodatkowy +1 ATAK, a wszystkie
    ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko z Ostrza
    Gorka - magicznego oręża nie można łączyć z inną bronią`,
    ],
    11: [
      "12 KLONTWA ZŁEGO KSIENZYCA",
      "RZUCONY NA 15+, POZOSTAJE W GRZE",
      `Klontwa Złego Ksienzycama zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Szaman musi widzieć swój cel). Dopóki zaklęcie
    'pozostaje w grze' ofiara klątwy zostaje automatycznie Wyłączona z akcji! jeżeli zostanie
    trafiona.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
  },
  "Dziedzina Boga-Pajonka": {
    1: [
      "1-2 WŁADCA PAJONKÓW",
      "RZUCONY AUTOMATYCZNIE",
      `To zaklęcie musi zostać rzucone przed potyczką. MAG podlega zasadzie specjalnej
    PRZYWOŁANIE (Pajonki).
    `,
    ],
    2: [
      "3 MUROŁAZY",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Szamana Leśnych Goblinów, również takie, które walczą wręcz.
    Dopóki zaklęcie 'pozostaje w grze' modele automatycznie zdają wszystkie testy
    wspinaczki. Ponadto objęte działaniem zaklęcia modele w ramach fazy ruchu mogą się
    wspiąć lub zejść na dystans równy podwojonej wartości współczynnika SZYBKOŚĆ
    liczonej w calach. Jeśli dystans na jaki model zamierza się wspiąć przekracza wartość
    podwojonego współczynnika SZYBKOŚĆ, to wspinaczka nie może być kontynuowana.
    `,
    ],
    3: [
      "4 PRZĘDNE NICI",
      "RZUCONY NA 7    ",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 8”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 OBMIERZŁY RÓJ",
      "RZUCONY NA 7+",
      `Obmierzły Rój jest magicznym pociskiem o zasięgu 18”. Po udanym rzuceniu zaklęcia
    magiczny pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża ZATRUTY ATAK`,
    ],
    5: [
      "6 CHITYNOWA SKÓRA",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Zaklęcie oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące się
    w odległości do 8" od Szamana Leśnych Goblinów, również takie, które walczą wręcz.
    Dopóki zaklęcie 'pozostaje w grze' modele otrzymują premię +2 do Ochrony Pancerza
    (do maksymalnego poziomu 0+) lub Ochronę Pancerza na 5+ jeśli nie posiadają
    PANCERZA.
    `,
    ],
    6: [
      "7 KLĄTWA BOGA-PAJONKA",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Boga-Pajonka ma zasięg 18” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika, także związany walką wręcz (wybrany przez kierującego
    MAGIEM gracza bez ograniczeń, z wyjątkiem tego, że Szaman Leśnych Goblinów musi
    widzieć swój cel). Dopóki zaklęcie 'pozostaje w grze' wszystkie trafienia zadane ofierze
    klątwy oraz wszystkim sprzymierzonym z postacią modelom w odległości do 6”
    podlegają zasadzie specjalnej ZATRUTY ATAK.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE PAJONKA",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża ZATRUTY ATAK.`,
    ],
    8: [
      "9 JAD PAJONKA",
      "RZUCONY NA 11+    ",
      `Jad Pajonka jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 18”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża ZATRUTY ATAK. `,
    ],
    9: [
      "10 ZBROJA PAJONKA",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Szamana Leśnych Goblinów, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4
    z cechą oręża DRUZGOCZĄCY.`,
    ],
    10: [
      "11 JADOWITE ŻONDŁO",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża ZATRUTY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Szaman Leśnych Goblinów władający Jadowitym Żondłem otrzymuje dodatkowy
    +1 ATAK, a wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może
    korzystać tylko z Jadowitego Żondła - magicznego oręża nie można łączyć z inną bronią.`,
    ],
    11: [
      "12 GNIEW BOGA-PAJONKA",
      "RZUCONY NA 14+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie lub też na dowolnego, sprzymierzonego bohatera
    lub stronnikaw odległości do 8”, nawet jeśli go nie widzi. Czar może zostać rzucony na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Cel zaklęcia staje się dziki i potężny niczym Arachnarok. Uzyskuje zdolność broń
    naturalna z cechą oręża ZATRUTY ATAK, +3 ATAKI, +2 do SIŁYoraz +1 do WT. Model
    pozostający pod wpływem zaklęcia, nie może używać oręża, tarczy & pancerza.`,
    ],
  },
  "Magia Pradawnych": {
    1: [
      "1-2 WYSSANIE MAGII",
      "RZUCONY NA 6+",
      `Czar działa do początku następnej fazy magii MAGA. Wartość rzucenia wszystkich zaklęć
    splatanych w czasie trwania Wyssania Magii zostaje zwiększony o +3.`,
    ],
    2: [
      "3 GWIEZDNY PORTAL",
      "RZUCONY NA 7+, POZOSTAJE W GRZE",
      `Udane rzucenie zaklęcia tworzy magiczne wrota łączące dwa punkty na stole, które muszą
    znajdować się w odległości do 24” od MAGA. Wrota należy traktować jak ‘zwykłe’
    drzwi, przez które modelmożewykonać ruch jak w fazie ruchu, który może być również
    ruchem szarży (szarża ta podlegać będzie wszystkim zasadom szarży, z wyjątkiem tego,
    że nie można próbować przejąć szarży modelu, który przekroczył Gwiezdny Portal).`,
    ],
    3: [
      "4 SKRZYDŁA TERRADONA",
      "RZUCONY NA 7+",
      `MAG może rzucić czar na samego siebie lub dowolny sprzymierzony model bohatera
    lub stronnika w odległości do 12”, nawet jeśli go nie widzi. Zaklęcie można rzucić na
    PIESZY model wielkości człowieka lub mniejszy (czar nie będzie zatem działał na
    modele na podstawkach 40x40 mm i większych), również związany walką wręcz.
    Udane rzucenie zaklęcia oznacza, że model może wykonać zwykły ruch LOTU na
    16”, który może być również ruchem szarży (szarża ta podlegać będzie wszystkim
    zasadom szarży, z wyjątkiem tego, że nie można próbować przejąć szarży modelu, który
    wykonał LOT). Model może nawet, jeśli gracz sobie tego życzy, przerwać walkę, w
    której brał udział, ale w takim wypadku nie będzie mógł szarżować.
    `,
    ],
    4: [
      "5 OGNISTY DECH",
      "RZUCONY NA 7+",
      `Ognisty Dech jest magicznym pociskiemo zasięgu 24”. Po udanym rzuceniu zaklęcia magiczny
    pocisk uderza w cel powodując trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    5: [
      "6 TRZECIE PROROCTWO",
      "RZUCONY NA 9+, POZOSTAJE W GRZE",
      `Moc zaklęcia oddziałuje na model MAGA i wszystkie sprzymierzone modele znajdujące
    się w odległości do 12" od Kapłana Skinka, również takie, które walczą wręcz. Dopóki
    zaklęcie 'pozostaje w grze' modele mogą przerzucić kostki w rzucie na trafienie, zranienie
    oraz Ochronę Pancerza i Ochronę Magiczną`,
    ],
    6: [
      "7 KLĄTWA QHAYSH",
      "RZUCONY NA 10+, POZOSTAJE W GRZE",
      `Klątwa Qhaysh ma zasięg 24” i po udanym rzuceniu może zostać skierowana na
    pojedynczy model przeciwnika (wybrany przez kierującego MAGIEM gracza bez
    ograniczeń, z wyjątkiem tego, że Kapłan Skinków musi widzieć swój cel). Po udanym
    rzuceniu zaklęcia należy umieścić obok ofiary czaru sześciościenną kostkę, tak aby
    wskazywała wynik ‘1’. Dopóki zaklęcie 'pozostaje w grze', na początku każdej kolejnej
    fazy magii MAGA należy obracać kostkę tak, by wskazywała wynik o +1 większy. Wynik
    na kostce oznacza ujemny modyfikator do współczynników SZ, S i WT jaki otrzymuje
    ofiara klątwy oraz wszystkie sprzymierzone z postacią modele w odległości do 6".
    Należy zauważyć, że współczynniki mogą zostać obniżone do minimalnej wartości 1.
    Model może znajdować się pod działaniem tylko jednej klątwy na raz.`,
    ],
    7: [
      "8 TCHNIENIE QHAYSH",
      "RZUCONY NA 11+",
      `Zaklęciemoże zostać rzucone na dowolny model przeciwnika, również związany walką
    wręcz, który znajduje się w polu widzenia MAGA.Po udanym rzuceniu zaklęcia należy użyć
    wzornika płomienia w ten sposób, że cieńszy jego koniec dotyka podstawki MAGA, a
    szeroki przykrywa wybrany na cel model przeciwnika. Wszystkie modele (wrogie i
    sprzymierzone), których podstawki są całkowicie przykryte wzornikiem, zostają objęte
    działaniem zaklęcia automatycznie, te modele, których podstawki są częściowo
    przykryte, dostają się pod działanie zaklęcia na 4+. Objęte działaniem czaru modele
    otrzymują trafienie o SILE 4 z cechą oręża PŁONĄCY ATAK.`,
    ],
    8: [
      "9 OGIEŃ SALAMANDRY",
      "RZUCONY NA 11+",
      `Ogień Salamandry jest niezwykle niebezpiecznym magicznym pociskiem o zasięgu 24”. Po
    udanym rzuceniu zaklęcia należy użyć 3” okrągłego wzornika i przykryć nim wybrany
    na cel model przeciwnika. Wszystkie modele (wrogie i sprzymierzone), których
    podstawki są całkowicie przykryte wzornikiem, zostają objęte działaniem zaklęcia
    automatycznie, te modele, których podstawki są częściowo przykryte, dostają się pod
    działanie zaklęcia na 4+. Objęte działaniem zaklęcia modele otrzymują trafienie o SILE
    4 z cechą oręża PŁONĄCY ATAK. `,
    ],
    9: [
      "10 ZBROJA QHAYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `Dopóki zaklęcie ‘pozostaje w grze’ MAG otrzymuje Magiczną Ochronę na 4+. Ponadto,
    wszystkie modele (wrogie i sprzymierzone) znajdujące się w kontakcie z podstawką
    Kapłana Skinków, na początku fazy walki wręcz otrzymują jedno trafienie o SILE 4 z cechą
    oręża PŁONĄCY ATAK.
    `,
    ],
    10: [
      "11 OSTRZE QHAYSH",
      "RZUCONY NA 12+, POZOSTAJE W GRZE",
      `MAG może rzucić zaklęcie na siebie. Dopóki zaklęcie ‘pozostaje w grze’ magiczne ostrze
    z cechą oręża PŁONĄCY ATAK oraz premia +3 do SIŁY materializuje się w dłoni MAGA.
    Ponadto, Kapłan Skinków władający Ostrzem Qhaysh otrzymuje dodatkowy +1 ATAK, a
    wszystkie ciosy trafiają na 4+. Póki MAG włada magicznym orężem może korzystać tylko
    z Ostrza Qhaysh - magicznego oręża nie można łączyć z inną bronią`,
    ],
    11: [
      "12 OGNISTE ODRODZENIE SALAMANDRY",
      "RZUCONY NA 14+, POZOSTAJE W GRZE",
      `Jeśli w trakcie rozgrywania potyczki MAG zostanie Wyłączony z akcji!, a zaklęcie 'pozostaje
    w grze', należy użyć 3” okrągłego wzornika i przykryć nim model Kapłana Skinków.
    Wszystkie modele (wrogie i sprzymierzone), których podstawki są całkowicie przykryte
    wzornikiem, zostają objęte działaniem zaklęcia automatycznie, te modele, których
    podstawki są częściowo przykryte, dostają się pod działanie zaklęcia na 4+ (za
    wyjątkiem samego rzucającego!). Objęte działaniem zaklęcia modele otrzymują trafienie
    o SILE 4 z cechą oręża PŁONĄCY ATAK.
    W najbliższej fazie ruchu model Kapłana Skinków powstaje podczas wykonywania
    pozostałych ruchów, tak jak postać która była Oszołomiona!. MAG może wykonać ruch (ale
    nie bieg), rzucać zaklęcia oraz strzelać. Jeśli model pozostaje związany walką wręcz to
    końca trwania tury w której powstał, będzie UDERZAŁ JAKO OSTATNI, bez względu na
    wartość I, oręż którym walczy lub inne zasady specjalne. Ponadto od momentu powstania
    Kapłana Skinków należy traktować tak, jakby wciąż posiadał 1 punkt ŻW.
    `,
    ],
  },

  ...rulebookMagic,
};
